var _defs, _g, _path, _g2, _g3, _path2, _path3, _g4, _path4, _path5, _g5, _g6, _g7, _g8, _path6, _path7, _g9, _path8, _path9, _g10, _path10, _path11, _g11, _g12, _path12, _path13, _path14, _g13, _g14, _g15, _g16, _g17, _path15, _path16, _g18, _path17, _g19, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g20, _path26, _g21, _g22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 351.517,
    height: 367.718,
    viewBox: "0 0 351.517 367.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72490",
    "data-name": "Path 72490",
    d: "M2264.518,957.449s-4.1-4.532-4.93-8.227-14.616-21.473-14.616-21.473l-7.9.036s-4.269,18.131-.086,22.718,3.317,3.776,8.958,3.443c0,0,2.734,5.238,1.765,9.99,0,0,8.613.5,9.307.507s7.5-6.995,7.5-6.995Z",
    transform: "translate(-2235.153 -927.75)",
    fill: "#ffc9b6",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40476",
    "data-name": "Group 40476",
    transform: "translate(-1439.686 -197.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40418",
    "data-name": "Group 40418",
    transform: "translate(1439.686 280.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    transform: "translate(0 107.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72430",
    "data-name": "Path 72430",
    d: "M1987.39,1504.077l-75.3-43.474,75.3-43.474,75.3,43.474Z",
    transform: "translate(-1803.306 -1326.701)",
    fill: "#939598",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72431",
    "data-name": "Path 72431",
    d: "M1514.985,1111.383l-75.3-43.474,75.3-43.474,75.3,43.474Z",
    transform: "translate(-1439.686 -1024.435)",
    fill: "#939598",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40258",
    "data-name": "Group 40258",
    transform: "translate(135.753 122.567)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40246",
    "data-name": "Group 40246",
    transform: "translate(61.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72432",
    "data-name": "Path 72432",
    d: "M2299.577,1182.959h-.01a2.558,2.558,0,0,1-2.547-2.568l.365-88.6a2.557,2.557,0,0,1,2.557-2.546h.01a2.557,2.557,0,0,1,2.547,2.568l-.365,88.6A2.557,2.557,0,0,1,2299.577,1182.959Z",
    transform: "translate(-2297.02 -1089.248)",
    fill: "#7498aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40257",
    "data-name": "Group 40257",
    transform: "translate(0 47.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40249",
    "data-name": "Group 40249",
    transform: "translate(92.818 16.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40248",
    "data-name": "Group 40248",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72433",
    "data-name": "Path 72433",
    d: "M2433.426,1365.984q.589.76,1.152,1.562.528.753,1.033,1.543.494.771.963,1.577t.922,1.656q.065.122.129.245.39.745.763,1.518.464.962.9,1.966.483,1.115.932,2.281.513,1.336.981,2.738.568,1.7,1.068,3.5.649,2.338,1.184,4.837.817,3.824,1.361,8.016.2,1.553.365,3.154l1.75,25.989-3.46,2.011-1.75-25.99q-.163-1.6-.365-3.154-.543-4.191-1.362-8.016-.534-2.5-1.183-4.837-.5-1.8-1.068-3.5-.468-1.4-.981-2.738-.449-1.167-.932-2.282-.435-1-.9-1.966-.373-.773-.763-1.518l-.129-.245q-.449-.845-.922-1.656c-.274-.47-.557-.928-.843-1.381v-6.729C2432.663,1365.028,2433.05,1365.5,2433.426,1365.984Z",
    transform: "translate(-2432.27 -1364.568)",
    fill: "#5d5d5d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40247",
    "data-name": "Group 40247",
    transform: "translate(0 6.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72434",
    "data-name": "Path 72434",
    d: "M2432.27,1393.8q.994,1.572,1.9,3.28c3.867,7.376,6.409,16.8,7.554,28.014l1.75,25.99-3.118-1.5-1.736-25.865c-1.022-9.949-3.156-18.25-6.345-24.708Z",
    transform: "translate(-2432.27 -1393.795)",
    fill: "#ccc"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40250",
    "data-name": "Group 40250",
    transform: "translate(61.467 54.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72435",
    "data-name": "Path 72435",
    d: "M2304.049,1577.5l-3.118-1.5c-.742-11.128-1.275-29.446-4.805-42.282l2.261-1.273C2302.873,1546.753,2303.178,1563.773,2304.049,1577.5Z",
    transform: "translate(-2296.126 -1532.44)",
    fill: "#ccc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72436",
    "data-name": "Path 72436",
    d: "M2313.3,1566.793l-3.461,2.011c-1.066-14.26-1.067-32.1-6.19-46.861l3.879-.8C2312.273,1535.635,2312.22,1552.764,2313.3,1566.793Z",
    transform: "translate(-2240.454 -1468.85)",
    fill: "#5d5d5d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72437",
    "data-name": "Path 72437",
    d: "M2168.75,1422.1c-.171.1-.339.19-.5.273C2168.415,1422.273,2168.583,1422.186,2168.75,1422.1Z",
    transform: "translate(-2136.231 -1392.608)",
    fill: "#5d5d5d"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40251",
    "data-name": "Group 40251",
    transform: "translate(21.411 44.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72438",
    "data-name": "Path 72438",
    d: "M2124.137,1493.073a7.011,7.011,0,0,0,2.762,2.761c2.513,1.541,3.951.6,7.064,2.214,1.355.693,1.044.858,2.948,1.9,1.934,1.065,3.279,1.779,5.1,1.841a6.365,6.365,0,0,0,3.93-.983,5.432,5.432,0,0,0,1.21-1.1.582.582,0,0,0-.01-.135v-6.444a1.65,1.65,0,0,0-2.565-.983,5.057,5.057,0,0,0-.848.786,4.972,4.972,0,0,1-3.775,1.851c-2.286-.248-3.806-2.172-4.768-5.337a2.714,2.714,0,0,0-1.541-1.738,10.769,10.769,0,0,0-6.589-.341,4.883,4.883,0,0,0-3.134,2.172,5.589,5.589,0,0,0-.321.662A5.52,5.52,0,0,0,2124.137,1493.073Z",
    transform: "translate(-2123.261 -1487.023)",
    fill: "#6979b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72439",
    "data-name": "Path 72439",
    d: "M2122.2,1503.369a4.706,4.706,0,0,0,2.214,3.7,35.357,35.357,0,0,0,6.423,2.844,4.616,4.616,0,0,1,1.707,1.045c.714.714,1.81,1.81,2.627,2.741a6.29,6.29,0,0,0,3.941,2.079,9.11,9.11,0,0,0,6.123-1.127,5.416,5.416,0,0,0,.838-4.292,5.433,5.433,0,0,1-1.21,1.1,6.364,6.364,0,0,1-3.931.983c-1.821-.062-3.165-.776-5.1-1.841-1.9-1.045-1.593-1.21-2.948-1.9-3.113-1.614-4.551-.672-7.064-2.214a7.013,7.013,0,0,1-2.762-2.761,5.517,5.517,0,0,1-.538-2.865A5.793,5.793,0,0,0,2122.2,1503.369Z",
    transform: "translate(-2122.179 -1497.67)",
    fill: "#46497f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72440",
    "data-name": "Path 72440",
    d: "M2181.165,1313.171h-13.7c-1.215,6.681-7.352,37.026-6.39,45.7,4.717.74,9.5,3.574,13.788,3.035a1.608,1.608,0,0,0,1.6-1.5C2177,1352.465,2181.863,1319.7,2181.165,1313.171Z",
    transform: "translate(-2130.629 -1308.766)",
    fill: "#b29b84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40253",
    "data-name": "Group 40253",
    transform: "translate(16.071 3.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40252",
    "data-name": "Group 40252",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72441",
    "data-name": "Path 72441",
    d: "M2168.081,1321.382q-3.711-2.2-7.427-4.35-2.041-1.178-4.085-2.333c-1.922-1.086-3.847-2.151-5.786-3.174-.97-.51-1.943-1.008-2.93-1.482-.495-.233-.993-.467-1.508-.681l-.02-.008-.212-.086-.163-.066c-.131-.051-.265-.1-.4-.148-.122-.044-.253-.086-.39-.125l-.066-.019-.048-.014c-.134-.036-.276-.07-.426-.1l-.043-.007a1.186,1.186,0,0,0-.12-.012h-.03c-.026,0-.052,0-.077,0s-.038,0-.057.007l-.024,0-.016,0c-.031.006-.061.012-.09.021l-.025.009-.024.009-.035.012a.724.724,0,0,0-.081.039l-.009,0-44.991,26.146a.748.748,0,0,1,.124-.057l.024-.009a.787.787,0,0,1,.131-.031l.024,0a.956.956,0,0,1,.134-.007h.021a1.129,1.129,0,0,1,.172.019c.169.032.326.071.474.112l.066.019c.136.04.268.082.39.125.139.047.273.1.4.149.064.025.127.051.191.077l.2.083c.515.214,1.013.448,1.509.681.987.474,1.96.972,2.93,1.482,1.939,1.023,3.865,2.088,5.787,3.174q2.045,1.154,4.085,2.333,3.717,2.146,7.427,4.35,10.715,6.354,21.406,12.957l44.991-26.146Q2178.783,1327.745,2168.081,1321.382Z",
    transform: "translate(-2098.993 -1308.777)",
    fill: "#c39133"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40254",
    "data-name": "Group 40254",
    transform: "translate(0 55.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72442",
    "data-name": "Path 72442",
    d: "M2031.16,1541.525a7.015,7.015,0,0,0,2.762,2.762c2.514,1.541,3.951.6,7.064,2.213,1.355.693,1.045.859,2.948,1.9,1.934,1.065,3.279,1.779,5.1,1.841a6.364,6.364,0,0,0,3.93-.983,5.432,5.432,0,0,0,1.21-1.1.6.6,0,0,0-.01-.134v-6.444a1.65,1.65,0,0,0-2.565-.983,5.042,5.042,0,0,0-.848.786,4.973,4.973,0,0,1-3.776,1.851c-2.286-.248-3.806-2.172-4.768-5.337a2.716,2.716,0,0,0-1.541-1.738,10.769,10.769,0,0,0-6.589-.341,4.883,4.883,0,0,0-3.134,2.172,2.972,2.972,0,0,0,.217,3.527Z",
    transform: "translate(-2030.284 -1535.474)",
    fill: "#6979b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72443",
    "data-name": "Path 72443",
    d: "M2029.219,1551.819a4.706,4.706,0,0,0,2.213,3.7,35.369,35.369,0,0,0,6.423,2.844,4.617,4.617,0,0,1,1.707,1.045c.714.714,1.81,1.81,2.627,2.741a6.29,6.29,0,0,0,3.941,2.079,9.109,9.109,0,0,0,6.123-1.128,5.416,5.416,0,0,0,.838-4.292,5.44,5.44,0,0,1-1.21,1.1,6.366,6.366,0,0,1-3.93.983c-1.821-.062-3.165-.776-5.1-1.841-1.9-1.044-1.593-1.21-2.948-1.9-3.113-1.614-4.551-.672-7.064-2.213a7.015,7.015,0,0,1-2.762-2.762,5.519,5.519,0,0,1-.538-2.865A5.789,5.789,0,0,0,2029.219,1551.819Z",
    transform: "translate(-2029.202 -1546.121)",
    fill: "#46497f"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40255",
    "data-name": "Group 40255",
    transform: "translate(9.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72444",
    "data-name": "Path 72444",
    d: "M2072.7,1344.941c.385-6.4-.319-3.873,0-15.4.127-4.589.322-7.637.713-13.733.49-7.641.821-10.574,2.3-14.225,2.217-5.457,4.615-6.629,5.346-6.942a9.768,9.768,0,0,1,6.611,0,18.1,18.1,0,0,1,7.972,5.278c4.3,4.2,10.313,5.782,22.328,8.939,13.29,3.492,16.615,5.805,16.615,5.805a26.272,26.272,0,0,1-.215,3.95q-1.346,2.548-2.68,5.356-1.49,3.151-2.709,6.12c-.153.466-.388,1.136-.722,1.927-.248.589-.553,1.248-.653,1.423-1.1,1.909-9.083.084-10.993-.349-10.585-2.4-8.888-1.629-11.343-2.431a53.989,53.989,0,0,1-19.249-11.38l-5.677,3.266-1.882,1.129c-1.089.842-.049,3.268,1.241,3.935a70.973,70.973,0,0,1,8.319,3.968c2.7,1.5.21,6.236.381,9.443q.42,7.868,1.13,15.24a15.047,15.047,0,0,1-9.5,1.818c-1.569-.242-4.845-.745-6.692-3.218C2071.656,1352.594,2072.38,1350.225,2072.7,1344.941Z",
    transform: "translate(-2072.268 -1294.04)",
    fill: "tan"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40256",
    "data-name": "Group 40256",
    transform: "translate(23.489 37.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72445",
    "data-name": "Path 72445",
    d: "M2137.629,1459.174l-.867-.5h0l-1.183-.683-2.16-1.246c-3.838,10.435-1.4,28.157-1.932,36.8l3.126,1.768-.142-24.646,1.033.354Z",
    transform: "translate(-2131.206 -1456.744)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72446",
    "data-name": "Path 72446",
    d: "M2147.241,1465.165l2.335,1.36c-2.625,10.278-.61,25.836-1.088,33.257l-3.461,2.011C2145.565,1493.456,2142.979,1475.054,2147.241,1465.165Z",
    transform: "translate(-2141.619 -1463.226)",
    fill: "#5d5d5d"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40261",
    "data-name": "Group 40261",
    transform: "translate(128.732 83.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40259",
    "data-name": "Group 40259",
    transform: "translate(0 76.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72447",
    "data-name": "Path 72447",
    d: "M2001.511,1353.089h-.012a2.8,2.8,0,0,1-2.788-2.811l.4-96.984a2.8,2.8,0,0,1,2.8-2.788h.012a2.8,2.8,0,0,1,2.788,2.811l-.4,96.984A2.8,2.8,0,0,1,2001.511,1353.089Z",
    transform: "translate(-1998.712 -1250.507)",
    fill: "#7498aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40260",
    "data-name": "Group 40260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72448",
    "data-name": "Path 72448",
    d: "M2001.511,1020.862h-.012a2.8,2.8,0,0,1-2.788-2.811l.4-96.984a2.8,2.8,0,0,1,2.8-2.788h.012a2.8,2.8,0,0,1,2.788,2.811l-.4,96.984A2.8,2.8,0,0,1,2001.511,1020.862Z",
    transform: "translate(-1998.712 -918.28)",
    fill: "#7498aa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40273",
    "data-name": "Group 40273",
    transform: "translate(7.891 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40268",
    "data-name": "Group 40268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40264",
    "data-name": "Group 40264",
    transform: "translate(15.481 105.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40263",
    "data-name": "Group 40263",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72449",
    "data-name": "Path 72449",
    d: "M1561.058,1056.979c.014-4.954,1.772-8.445,4.6-10.089l4.293-2.495c-2.829,1.644-4.587,5.135-4.6,10.09l-1.176,33.691-4.293,2.495Z",
    transform: "translate(-1555.575 -1037.79)",
    fill: "#5d5d5d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72450",
    "data-name": "Path 72450",
    d: "M1605.726,1051.756c-.02-.155-.044-.311-.066-.466-.039-.276-.079-.552-.125-.829-.03-.177-.063-.356-.1-.534-.048-.265-.1-.53-.153-.8-.029-.139-.06-.279-.09-.418-.146-.67-.309-1.342-.494-2.015-.029-.1-.06-.21-.09-.315q-.24-.849-.518-1.7c-.021-.063-.039-.125-.06-.188-.186-.557-.388-1.113-.6-1.667q-.078-.207-.16-.412-.269-.689-.561-1.373c-.037-.086-.072-.173-.109-.26q-.337-.774-.706-1.541c-.062-.13-.127-.26-.19-.39q-.3-.609-.614-1.21c-.066-.127-.131-.254-.2-.38q-.4-.753-.832-1.493c-.051-.087-.1-.173-.155-.259q-.384-.652-.788-1.29c-.078-.123-.156-.247-.235-.37q-.5-.77-1.018-1.52c-.05-.072-.1-.142-.153-.214q-.546-.772-1.12-1.518c-.052-.067-.1-.136-.154-.2q-.718-.923-1.477-1.8c-.067-.077-.132-.156-.2-.232q-.468-.535-.949-1.051l-.045-.049q-.505-.538-1.025-1.051c-.073-.072-.147-.141-.22-.213q-.676-.66-1.372-1.279c-.04-.036-.08-.073-.12-.108-.48-.422-.969-.823-1.462-1.211-.094-.074-.187-.148-.281-.221q-.728-.56-1.473-1.07c-.088-.06-.177-.118-.266-.177-.521-.347-1.046-.681-1.577-.988-.426-.246-.847-.469-1.267-.681-.121-.061-.242-.119-.362-.177q-.478-.231-.949-.433c-.114-.049-.228-.1-.341-.146-.293-.12-.583-.229-.871-.332-.077-.028-.156-.06-.232-.086q-.546-.187-1.082-.333c-.216-.06-.43-.11-.643-.16-.091-.021-.183-.047-.273-.066q-.457-.1-.9-.167c-.454-.07-.9-.11-1.337-.134-.09-.005-.18-.011-.269-.014-.395-.014-.783-.013-1.163.009-.064,0-.126.012-.19.017q-.465.035-.914.107c-.093.014-.186.029-.278.046-.341.063-.678.137-1,.232l-.034.011c-.313.092-.617.2-.916.323-.086.035-.171.072-.256.109q-.379.166-.741.362c-.08.043-.162.081-.241.127l4.293-2.5.11-.063c.042-.023.087-.04.129-.063q.362-.2.742-.363c.047-.021.09-.048.138-.068s.08-.026.118-.042c.3-.121.6-.231.917-.324l.027-.009h.005c.327-.095.663-.168,1-.232.04-.007.078-.02.118-.027s.107-.01.159-.019q.45-.071.914-.107c.047,0,.092-.014.14-.016.016,0,.033,0,.049,0,.38-.022.769-.023,1.164-.01.039,0,.076,0,.116,0s.1.012.152.015c.439.025.883.064,1.338.134h.006q.444.068.9.167c.092.02.186.046.278.068.2.045.39.089.588.143l.052.016q.534.147,1.08.333c.078.027.158.059.236.087.288.1.577.211.869.331.04.016.08.029.12.046.073.03.147.069.22.1q.471.2.948.433c.121.059.242.117.365.179.419.212.84.434,1.266.68.531.307,1.055.641,1.576.988.089.059.178.117.267.177q.745.508,1.472,1.069c.095.073.189.147.283.221.493.388.981.789,1.461,1.209l.122.111q.7.616,1.369,1.276c.045.044.093.084.138.129.028.028.056.058.084.086q.518.514,1.024,1.05l.052.057q.478.511.943,1.044c.03.034.061.066.09.1s.072.09.109.133q.757.876,1.477,1.8c.014.018.03.035.044.053.037.048.071.1.108.147q.573.746,1.121,1.519c.035.049.073.1.108.146.016.023.03.046.046.068q.523.749,1.018,1.52c.032.05.068.1.1.149.046.073.089.148.135.221q.4.64.79,1.292c.037.063.078.124.114.188l.038.068q.43.74.833,1.5c.023.043.049.086.072.129.044.082.083.166.126.248q.316.6.614,1.212c.041.084.086.166.126.25.022.046.042.093.064.14q.367.766.706,1.542c.009.021.02.042.029.063.027.064.052.129.079.193q.294.686.563,1.376c.03.078.066.156.1.234.023.059.042.119.064.179.21.555.412,1.111.6,1.668.005.017.012.033.018.049.015.045.026.089.041.134q.281.851.52,1.7c.02.069.044.139.064.208.01.034.016.068.025.1q.276,1.009.494,2.014c.013.061.032.123.045.183.017.08.029.159.046.239.054.264.1.527.152.791.032.179.066.358.1.536.047.278.087.556.126.833.018.126.041.253.057.379,0,.027,0,.054.008.082.073.571.127,1.137.168,1.7.009.125.016.249.023.373.034.575.058,1.147.057,1.713l.981,34.8-4.293,2.5-.981-34.8c0-.565-.023-1.138-.057-1.713-.007-.124-.015-.249-.023-.373C1605.853,1052.892,1605.8,1052.326,1605.726,1051.756Z",
    transform: "translate(-1564.679 -1015.716)",
    fill: "#5d5d5d"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40262",
    "data-name": "Group 40262",
    transform: "translate(0 2.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72451",
    "data-name": "Path 72451",
    d: "M1562.477,1029.275c-11.048-6.379-20.069-1.258-20.122,11.426l-1.175,33.556,4.307,2.663,1.176-33.691c.028-9.973,7.122-14.015,15.8-9s15.727,17.218,15.7,27.191l.987,34.939,4.308,2.311-.981-34.8C1582.487,1051.156,1573.531,1035.657,1562.477,1029.275Z",
    transform: "translate(-1541.179 -1026.531)",
    fill: "#ccc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40267",
    "data-name": "Group 40267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40266",
    "data-name": "Group 40266",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72452",
    "data-name": "Path 72452",
    d: "M1475.818,589.25a.924.924,0,0,0-.343-.122h-.006a.5.5,0,0,0-.3.053l55.287-32.13a.438.438,0,0,1,.043-.021.45.45,0,0,1,.1-.029.468.468,0,0,1,.055-.007.5.5,0,0,1,.061,0l.043,0h.006l.02,0a.738.738,0,0,1,.082.017.927.927,0,0,1,.109.037,1.156,1.156,0,0,1,.132.065,1.563,1.563,0,0,1,.313.243c.011.011.022.024.033.035l.015.015c.018.019.036.037.054.058s.05.059.074.091.041.055.061.083.036.053.054.08.032.051.047.077l.012.02q.293.515.568,1.032c.021.039.039.078.059.117q.344.652.661,1.306c.015.032.033.064.048.1l0,.01c.252.524.49,1.048.719,1.573.024.054.051.108.074.162.033.076.06.152.093.227.276.646.542,1.292.79,1.937l0,.01c.012.031.022.061.034.092q.269.705.52,1.407c.057.161.113.321.169.482q.186.529.363,1.055c.029.085.06.171.088.257q.087.259.171.518c.257.794.5,1.585.734,2.374.077.258.148.514.222.771.112.385.227.771.333,1.155.034.121.063.24.1.361.17.617.33,1.232.488,1.846.075.291.154.583.226.873q.337,1.349.645,2.689.318,1.384.612,2.76c.092.432.172.86.261,1.291q.189.916.37,1.828.285,1.447.548,2.885c.106.577.213,1.154.314,1.728.183,1.042.357,2.08.526,3.117.078.477.161.956.236,1.432q.357,2.252.683,4.492.325,2.288.62,4.563c0,.03.007.06.011.09q.418,3.227.776,6.428.09.782.175,1.563.351,3.191.66,6.364c.541,5.637.981,11.212,1.305,16.767l-55.287,32.129c-.324-5.555-.764-11.13-1.305-16.766q-.3-3.173-.661-6.367-.085-.777-.174-1.556c-.243-2.137-.5-4.279-.776-6.431q-.3-2.321-.63-4.654-.326-2.24-.683-4.493c-.075-.473-.157-.949-.235-1.423-.17-1.041-.344-2.083-.528-3.129-.1-.571-.208-1.145-.313-1.717q-.265-1.445-.55-2.9-.179-.91-.369-1.824c-.278-1.346-.561-2.693-.873-4.05q-.306-1.34-.645-2.689c-.073-.29-.151-.582-.227-.873-.158-.614-.319-1.229-.488-1.846-.138-.5-.282-1.01-.429-1.516-.075-.257-.146-.514-.223-.771-.235-.789-.478-1.58-.734-2.374-.085-.257-.173-.516-.26-.774q-.178-.528-.364-1.058c-.055-.159-.111-.318-.168-.476q-.25-.7-.516-1.4c-.015-.039-.028-.077-.043-.116-.247-.644-.513-1.289-.789-1.934-.056-.131-.111-.262-.168-.392-.229-.525-.467-1.049-.719-1.573-.015-.031-.032-.062-.047-.093q-.319-.659-.666-1.316c-.2-.384-.41-.768-.628-1.15a2.156,2.156,0,0,0-.3-.409l-.015-.016A1.617,1.617,0,0,0,1475.818,589.25Z",
    transform: "translate(-1474.888 -556.993)",
    fill: "#c38f51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72453",
    "data-name": "Path 72453",
    d: "M1595.936,953.394a4.907,4.907,0,0,0-.128-.583l-.012-.039a5.727,5.727,0,0,0-.217-.609l-.011-.026a6.449,6.449,0,0,0-.3-.6l-.02-.035a6.36,6.36,0,0,0-.359-.561l-.03-.041a5.912,5.912,0,0,0-.389-.477c-.026-.029-.052-.056-.078-.083-.108-.116-.223-.222-.339-.324-.048-.043-.095-.088-.144-.128a4.124,4.124,0,0,0-.484-.344l-50.846-28.27,55.287-32.129,50.846,28.269a4.089,4.089,0,0,1,.484.345c.05.04.1.085.145.128.069.061.139.117.206.182.046.045.088.094.132.141.026.028.053.055.079.084s.047.048.069.074q.108.125.211.257c.037.048.073.1.109.148l.029.039.036.049q.078.111.151.226t.135.221c.013.021.024.043.036.065l.02.036c.022.04.045.08.067.12.039.073.077.148.113.223s.071.151.1.227l.013.032.011.026c.025.059.049.117.072.176q.047.123.089.247c.021.062.038.124.057.186l.012.039c0,.014.009.028.013.042.028.1.052.2.074.3.017.08.028.16.041.24,0,.026.01.051.013.077s.007.034.009.051a3.912,3.912,0,0,1,.032.557,1.793,1.793,0,0,1-.756,1.609l-55.287,32.129a1.793,1.793,0,0,0,.756-1.609,3.891,3.891,0,0,0-.041-.608C1595.946,953.445,1595.94,953.419,1595.936,953.394Z",
    transform: "translate(-1526.78 -812.655)",
    fill: "#c38f51"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40265",
    "data-name": "Group 40265",
    transform: "translate(0 32.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72454",
    "data-name": "Path 72454",
    d: "M1474.885,696.645a.664.664,0,0,0-.651-.07c-.361.2-.374.855-.028,1.476a50.618,50.618,0,0,1,3.851,9.466c.994,3.232,1.8,6.464,2.487,9.682,1.363,6.429,2.336,12.783,3.139,19.072.785,6.279,1.393,12.5,1.865,18.648s.839,12.278,1.046,18.263l.042,1.788,1.591.952,52.267,31.3c1.473.851,2.638.214,2.672-1.408a5.737,5.737,0,0,0-2.561-4.537L1489.758,773c-.324-5.555-.765-11.129-1.305-16.766-.6-6.275-1.333-12.6-2.242-19.008-.932-6.418-2.029-12.9-3.551-19.533-.758-3.313-1.645-6.667-2.745-10.069a55.128,55.128,0,0,0-4.368-10.28A1.893,1.893,0,0,0,1474.885,696.645Z",
    transform: "translate(-1473.954 -696.518)",
    fill: "#f8d5a4"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40270",
    "data-name": "Group 40270",
    transform: "translate(40.597 92.989)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72455",
    "data-name": "Path 72455",
    d: "M1850.97,1281.7a30.469,30.469,0,0,0-.576,6.718,2.967,2.967,0,0,0,.584,1.682,4.2,4.2,0,0,0,2.553,1.591c2.289,4.725,5.142,8.1,9.189,8.605,3.518.537,5.349-.108,5.945-1.62.444-1.688-.307-3.674-1.9-5.869l-3.4-4.661a8.656,8.656,0,0,1-1.7-4.8l-.337-1.647Z",
    transform: "translate(-1804.292 -1207.803)",
    fill: "#42210b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72456",
    "data-name": "Path 72456",
    d: "M1816.731,1112.862c-.629-9.546-.118-22.12.751-35.644l.671-17.087-26.954-1.068,11.468,12.44a5.578,5.578,0,0,1,1.462,4.178l-.819,11.473a13.722,13.722,0,0,0-.011,1.8l1.376,23.183Z",
    transform: "translate(-1758.742 -1036.437)",
    fill: "#647368"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72457",
    "data-name": "Path 72457",
    d: "M1802.672,1071.5a5.581,5.581,0,0,1,1.462,4.179l-.125,1.739c.6.459,1.08.861,1.143.912,1.223,1.032,1.488,1.528,2.505,1.964,1.371.587,1.91.128,3.252.61a6.706,6.706,0,0,1,2.913,2.372,13.443,13.443,0,0,1,2.437,5.08c.171.55.348,1.194.507,1.918.182-4.2.43-8.574.718-13.058l.673-17.085-26.954-1.069Z",
    transform: "translate(-1758.746 -1036.438)",
    fill: "#1a1a1a",
    opacity: 0.31,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40269",
    "data-name": "Group 40269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72458",
    "data-name": "Path 72458",
    d: "M1943.172,1246.424c.186,1.7.362,3.824.533,5.428a2.314,2.314,0,0,0,1.613,2,16.79,16.79,0,0,0,4.721.592c3.828,3.019,8.277,3.636,13.161,3.533a6.575,6.575,0,0,0,4.343-1.851,2.582,2.582,0,0,0-.2-3.9,3.15,3.15,0,0,0-.344-.248c-2.472-.959-5.033-1.988-7.4-3.079a3.959,3.959,0,0,1-1.465-1.04c-1.7-1.715-3.455-3.581-5.221-5.284-3.226,1.171-6.434,2.4-9.647,3.6C1943.234,1246.262,1943.2,1246.325,1943.172,1246.424Z",
    transform: "translate(-1875.718 -1177.689)",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72459",
    "data-name": "Path 72459",
    d: "M1658.142,964.745q-1.427,1.74-2.868,3.677c-1.912,2.579-3.576,5.1-5.026,7.5a46.731,46.731,0,0,0,51.573,14.722c2.731,2.6.494,8.6,2.479,12.237,2.278,8.4,7.417,15.536,10.8,23.482.692,1.541,1.368,3.1,2.021,4.658h0v0c4.094-1.224,8.379-2.042,12.414-3.335a348.645,348.645,0,0,0-12.98-37.98c-4.019-9.839-6.941-15.654-12.954-20.685a39.325,39.325,0,0,0-17.721-8.221c-5.435.781-10.864,1.54-16.3,2.312Q1663.87,963.926,1658.142,964.745Z",
    transform: "translate(-1650.248 -960.806)",
    fill: "#647368"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40272",
    "data-name": "Group 40272",
    transform: "translate(40.597 8.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72460",
    "data-name": "Path 72460",
    d: "M1805.3,893.39l.019.175a1.087,1.087,0,0,0,.009-.157C1805.322,893.4,1805.312,893.4,1805.3,893.39Z",
    transform: "translate(-1769.597 -824.521)",
    fill: "#7f726b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72461",
    "data-name": "Path 72461",
    d: "M1723.406,759.188l.015-.025a.794.794,0,0,0,.029-.083c-.007-.018-.018-.04-.025-.061C1723.413,759.131,1723.406,759.188,1723.406,759.188Zm-1.967-39.427.263,3.967v0a1.01,1.01,0,0,1,.922.533c.123.335-.068.742-.472,1.113a32.033,32.033,0,0,1,3.545,7.281c-.346-3.39-.807-6.474-1.16-9.082-.122-.915-.277-1.762-.458-2.536v0Zm-12.789.227a42.867,42.867,0,0,0,5.764,6.244,23.287,23.287,0,0,1,4.517,5.779,39.951,39.951,0,0,1-.245-5.761.721.721,0,0,1-.4-.4.942.942,0,0,1,.26-.894l-1.182-2.136-.2,1.355A27.09,27.09,0,0,1,1708.649,719.988Zm8.369-10.884c.49.306,1.03.66,1.607,1.059l-.357-1.139C1717.865,709.05,1717.443,709.075,1717.018,709.1Z",
    transform: "translate(-1695.2 -682.611)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72462",
    "data-name": "Path 72462",
    d: "M1687.286,763.8l-1.311-12.7-.018-.173.025.014c.094-2.295,1.091-28.756-2.619-34-2.187-3.088-4.882-6.37-6.816-8.639h0c-.908.04-2.021.094-3.228.166l.357,1.138.71,2.288.05.166s3.181,1.783,4.694,8.419v0c.18.774.335,1.621.458,2.536.353,2.608.814,5.692,1.16,9.082a.005.005,0,0,0,0,.007,73.04,73.04,0,0,1-.014,17.023,45.37,45.37,0,0,1-2.234,9.392.028.028,0,0,0,.007.018c-.011.022-.025.043-.036.065l-.015.025s.007-.058.018-.169a59.056,59.056,0,0,0-.011-11.258v0a40.331,40.331,0,0,0-4.478-15.74s0,0,0-.007a23.286,23.286,0,0,0-4.518-5.779,42.867,42.867,0,0,1-5.764-6.244c-4.024-5.595-1.225-7.112-1.225-7.112l.738-2.742c-3.821,3.543-6.265,6.038-6.265,6.038l-.256.18-4.024,2.835,0,0c.133.148,4.161,4.687,4.655,18.273a96.33,96.33,0,0,1-.7,14.706s11.355,5.109,18.82,10.747c.108.083.216.162.324.249.447.342.879.684,1.29,1.03l-3.74,9.374-11.089-4.676-4.276-1.8h0l-4.928-2.079c-.072.493-.141.98-.209,1.459-.187,1.333-.378,2.608-.566,3.819-1.059,6.863-2,11.5-2,11.5,27.269,11.046,38.736-1.027,38.736-1.027Z",
    transform: "translate(-1650.247 -682.057)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72463",
    "data-name": "Path 72463",
    d: "M1749.5,729.582l3.383,1.632,2.641,1.275c-1.513-6.636-4.694-8.419-4.694-8.419l-.05-.166h0l-1.005,4.478Z",
    transform: "translate(-1726.643 -694.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72464",
    "data-name": "Path 72464",
    d: "M1747.66,755.388a.941.941,0,0,0-.26.893.721.721,0,0,0,.4.4,39.937,39.937,0,0,0,.245,5.761v0a40.329,40.329,0,0,1,4.481,15.745v0a59.051,59.051,0,0,1,.011,11.258c.007.022.018.043.025.061a45.377,45.377,0,0,0,2.234-9.392,73.04,73.04,0,0,0,.014-17.023.005.005,0,0,1,0-.007,32.031,32.031,0,0,0-3.545-7.281c.4-.371.594-.778.472-1.113a1.01,1.01,0,0,0-.922-.533v0l-.263-3.967-3.382-1.632h0l-.7,4.689Z",
    transform: "translate(-1724.318 -713.043)",
    fill: "#c38f51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40271",
    "data-name": "Group 40271",
    transform: "translate(5.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72465",
    "data-name": "Path 72465",
    d: "M1710.37,663.8a1.45,1.45,0,0,0-.512.411,2.637,2.637,0,0,0-.439,1.336,13.627,13.627,0,0,0,.065,2.311,4.906,4.906,0,0,1-.048.545,1.952,1.952,0,0,1-1.7,1.641c-.887.108-1.822.2-2.8.257-1.638.1-3.163.11-4.557.061a10.769,10.769,0,0,0-3.225-.362,1.4,1.4,0,0,1-.668-.208c-.942-.473-1.14-2.39-.872-3.772a5.56,5.56,0,0,1,.835-2.012,5.819,5.819,0,0,0,.716-1.508,5.954,5.954,0,0,0,.238-2.2,5.385,5.385,0,0,0-.334-1.653v0c0-.009,0-.017,0-.023a1.96,1.96,0,0,0,.038-.8c-.2-1.275-1.531-1.45-2.345-3.223-.6-1.3-.7-2.976-.153-3.266.632-.34,2.123,1.191,2.778,1.979,1.28,1.533,1.547,2.823,1.844,2.749.318-.082.381-1.67-.1-3.145-.338-1.037-.64-1.073-.77-1.825a3.866,3.866,0,0,1,1.152-3.362c.88-.788,1.849-.687,4.132-.751a46.446,46.446,0,0,0,5.136-.33,6.339,6.339,0,0,1-1.9.985c-2.182.684-4.037-.114-5.849,1.374a3.476,3.476,0,0,0-1.389,2.045c-.239,1.47,1.058,2.121,1.167,4.1.075,1.359-.51,1.555-.48,2.654.066,2.526,3.23,4.361,3.889,4.743A10.443,10.443,0,0,0,1710.37,663.8Z",
    transform: "translate(-1690.015 -634.596)",
    fill: "#e4b69d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72466",
    "data-name": "Path 72466",
    d: "M1698.44,600.565c-2.806-4.743-8.274-5.736-9.279-5.92-.661-.119-6.808-1.236-8.8,1.509-.361.5-.547,1.072-1.537,2.513-.187.272-.354.5-.507.71-.685.92-1.061,1.26-1.437,1.833-1.4,2.128-1.02,4.676-.868,5.867a13.261,13.261,0,0,0,1.662,4.712c1.131,2.212,1.735,3.4,3.084,4.378a5.245,5.245,0,0,1,1.979,1.839,3.37,3.37,0,0,1,.163.358,2.021,2.021,0,0,0,.042-.82c-.2-1.275-1.531-1.45-2.344-3.223-.6-1.3-.7-2.976-.154-3.267.632-.34,2.124,1.191,2.778,1.979,1.28,1.533,1.548,2.823,1.845,2.749.318-.081.381-1.67-.1-3.145-.338-1.037-.64-1.073-.77-1.825a3.865,3.865,0,0,1,1.153-3.362c.689-.617,1.436-.689,2.824-.722.384-.009.813-.015,1.307-.029a46.451,46.451,0,0,0,5.136-.33,12.985,12.985,0,0,0,1.756-.357,10.4,10.4,0,0,0,2.882-1.324c-.006-.047-.014-.1-.02-.146a2.744,2.744,0,0,0,.4-1.122C1699.688,602.9,1699.379,602.149,1698.44,600.565Z",
    transform: "translate(-1675.847 -594.32)",
    fill: "#8c6239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72467",
    "data-name": "Path 72467",
    d: "M1731.285,655.906a3,3,0,0,1-.822,1.44c-.729.638-1.534.513-2.179.832a10.442,10.442,0,0,1-6.153-1.25c-.659-.383-3.823-2.217-3.889-4.743-.03-1.1.555-1.294.48-2.654-.109-1.978-1.406-2.629-1.167-4.1a3.477,3.477,0,0,1,1.389-2.045c1.812-1.488,3.667-.69,5.849-1.374a6.346,6.346,0,0,0,1.9-.985,13,13,0,0,0,1.756-.357,10.4,10.4,0,0,0,2.882-1.324c.373,2.666.608,4.988.761,6.868C1732.092,646.214,1732.569,652.048,1731.285,655.906Z",
    transform: "translate(-1707.928 -628.977)",
    fill: "#efc7b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72468",
    "data-name": "Path 72468",
    d: "M1708.373,701.761c-.134.456-1.056.268-2.576.924a7.881,7.881,0,0,0-2.207,1.44l.73-2a5.116,5.116,0,0,0-.067-3.467v0c0-.009,0-.017,0-.023.243.1.5.222.757.354C1705.156,699.057,1708.632,700.879,1708.373,701.761Z",
    transform: "translate(-1697.201 -674.61)",
    fill: "#cea28b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72469",
    "data-name": "Path 72469",
    d: "M1701.177,732.223a27.091,27.091,0,0,0,8.51,4.186l.2-1.354.7-4.691a10.129,10.129,0,0,1-2.025-.079c-5.209-.724-8.885-5.364-8.885-5.364S1697.269,726.744,1701.177,732.223Z",
    transform: "translate(-1687.729 -694.846)",
    fill: "#fff"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72470",
    "data-name": "Path 72470",
    d: "M1706.88,1185.942h-.012a2.8,2.8,0,0,1-2.788-2.811l.4-96.984a2.8,2.8,0,0,1,2.8-2.788h.012a2.8,2.8,0,0,1,2.788,2.811l-.4,96.984A2.8,2.8,0,0,1,1706.88,1185.942Z",
    transform: "translate(-1643.196 -962.148)",
    fill: "#7498aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40275",
    "data-name": "Group 40275",
    transform: "translate(45.414 74.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40274",
    "data-name": "Group 40274",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72471",
    "data-name": "Path 72471",
    d: "M1809.481,1095.906c-.008.217-.02.434-.033.651-.011.188-.022.377-.036.565-.017.219-.039.437-.061.655-.019.187-.037.373-.059.56-.027.22-.058.44-.09.659-.026.185-.051.37-.081.554-.036.222-.078.443-.119.665-.034.182-.065.364-.1.546-.045.218-.1.436-.145.653-.042.183-.081.366-.126.549-.055.221-.115.441-.175.661-.048.179-.094.358-.146.537-.065.225-.138.45-.208.675-.055.173-.106.346-.163.519-.078.234-.164.467-.247.7-.059.163-.113.326-.175.489-.129.342-.267.684-.408,1.025-.024.059-.046.118-.071.177q-.253.6-.532,1.2c-.056.121-.119.241-.177.362-.133.276-.266.553-.407.828-.079.154-.164.306-.245.46-.128.241-.256.483-.391.723q-.268.478-.553.953l-.112.186c-.2.332-.408.662-.622.991l-.087.133q-.326.5-.67.992l-.039.057c-.234.335-.477.668-.725,1l-.123.166q-.356.473-.73.943c-.063.079-.127.158-.191.237q-.341.423-.7.843l-.129.154q-.409.478-.837.952l-.21.231q-.376.412-.767.821l-.15.158q-.452.468-.922.932l-.229.224q-.412.4-.837.8l-.171.161c-.173.16-.353.319-.53.478-.217.2-.432.392-.654.587-.179.157-.365.313-.548.469-.222.19-.443.381-.67.569-.19.158-.386.314-.58.47-.228.185-.455.37-.688.553-.2.157-.406.313-.61.469-.235.18-.469.361-.709.541-.209.156-.423.31-.636.464-.243.177-.485.354-.733.529-.219.154-.442.307-.664.461-.25.173-.5.346-.754.517-.228.153-.46.3-.691.455-.258.169-.516.339-.778.506-.236.151-.477.3-.717.449-.266.165-.531.331-.8.495-.425.258-.853.515-1.29.768-.645.375-1.3.74-1.959,1.1-.19.1-.381.206-.572.308q-.767.411-1.547.81c-.175.089-.349.18-.524.269q-1.013.509-2.044,1c-.121.057-.243.112-.364.168q-.87.407-1.756.8l-.631.276q-.863.375-1.739.735c-.145.06-.289.121-.435.181q-1.076.437-2.171.853c-.182.069-.365.136-.548.2q-.859.321-1.728.63-.326.116-.652.23-1.046.363-2.1.71l-.165.055q-.956.309-1.922.6c-.143.044-.288.085-.432.128-.5.151-1,.3-1.511.445-.238.068-.477.133-.716.2-.415.116-.829.232-1.246.344-.27.073-.543.141-.814.212-.388.1-.776.2-1.166.3-.287.072-.577.141-.865.211-.377.091-.754.183-1.133.271-.3.069-.6.136-.895.2-.373.084-.746.168-1.121.249-.3.066-.609.129-.915.193q-.557.116-1.116.229-.464.092-.929.181-.558.107-1.117.21-.4.074-.809.145-.948.168-1.9.323c-.2.032-.393.066-.59.1q-1.219.193-2.445.365c-.176.025-.352.047-.527.071q-.99.135-1.983.256l-.746.089q-1.025.12-2.054.225l-.472.049q-1.113.11-2.229.2l-.375.029q-.931.075-1.865.139c-.258.018-.517.032-.776.048q-.737.046-1.475.086c-.29.015-.581.029-.871.042q-.7.033-1.4.059-.461.017-.922.032-.591.018-1.182.031-.482.011-.964.02-.6.01-1.191.014c-.318,0-.636.006-.954.007-.4,0-.806,0-1.209,0-.312,0-.624,0-.936-.006-.413,0-.826-.013-1.238-.022-.3-.006-.607-.011-.91-.019-.38-.01-.759-.024-1.139-.036-.321-.011-.641-.02-.961-.033-.385-.016-.769-.035-1.154-.053-.314-.015-.629-.029-.943-.046-.392-.021-.784-.047-1.176-.071-.306-.019-.612-.036-.918-.057-.4-.028-.809-.06-1.213-.091-.292-.022-.583-.043-.875-.067-.422-.035-.843-.075-1.263-.113-.272-.025-.545-.048-.817-.074-.476-.046-.95-.1-1.425-.149-.216-.023-.432-.044-.648-.068q-1.035-.116-2.067-.246l-.2-.027q-.931-.119-1.858-.249c-.166-.023-.331-.05-.5-.074-.532-.077-1.064-.155-1.594-.238-.257-.041-.513-.084-.77-.126-.437-.071-.875-.142-1.31-.217-.284-.049-.567-.1-.851-.152-.406-.073-.813-.146-1.218-.222-.3-.056-.59-.114-.885-.172-.391-.076-.782-.153-1.171-.233-.277-.057-.553-.116-.829-.174q-.673-.142-1.342-.291-.423-.094-.843-.191-.658-.151-1.313-.309c-.275-.066-.55-.132-.824-.2q-.687-.17-1.369-.349c-.246-.064-.492-.126-.737-.191q-.842-.224-1.676-.46l-.4-.11q-1.2-.342-2.379-.708c-.213-.065-.424-.132-.636-.2q-.954-.3-1.9-.615c-.174-.058-.35-.115-.524-.174q-1.156-.392-2.295-.806c-.17-.062-.338-.126-.507-.188q-.924-.341-1.836-.7c-.239-.093-.479-.186-.717-.281s-.5-.2-.744-.3q-.483-.2-.962-.4-.372-.156-.741-.315-.475-.2-.945-.412-.365-.161-.729-.325-.471-.213-.938-.431c-.237-.11-.475-.22-.711-.332q-.473-.224-.941-.454c-.227-.111-.456-.222-.682-.334-.324-.161-.644-.326-.965-.491-.21-.108-.421-.215-.63-.324-.352-.184-.7-.372-1.047-.56-.173-.094-.349-.186-.521-.281q-.777-.427-1.54-.867c-17.012-9.822-25.509-22.715-25.472-35.588l-.03,10.494c-.036,12.873,8.46,25.766,25.472,35.588q.763.44,1.54.867c.172.094.347.186.521.28.348.188.7.376,1.047.56.209.109.42.216.63.324.321.165.641.33.965.491.226.113.454.223.682.334.313.153.625.3.94.455.236.112.474.222.711.333q.468.217.938.431.363.164.73.325.471.208.945.412.369.159.741.315.479.2.962.4.372.151.744.3c.118.047.234.1.353.143s.243.091.364.138q.912.356,1.836.7c.169.062.337.126.507.188q1.139.415,2.295.806c.174.059.349.115.524.174q.944.315,1.9.615c.211.066.422.133.634.2q1.184.365,2.38.708l.039.012c.117.033.236.064.353.1q.838.236,1.682.462c.245.065.49.127.736.191q.684.178,1.371.349c.273.068.547.133.821.2q.656.158,1.315.31l.843.191q.669.149,1.342.29c.18.038.358.079.539.117l.291.058c.389.08.78.156,1.171.233.295.058.589.116.885.172.405.076.812.149,1.219.222.283.051.566.1.851.152.435.075.873.146,1.31.217.257.042.513.086.77.126.53.083,1.062.161,1.594.239.156.022.31.048.466.07l.031,0q.927.131,1.858.249l.2.027q1.031.131,2.067.246c.216.024.432.045.648.068.474.051.949.1,1.425.149.272.026.545.049.818.074.421.039.841.078,1.263.113l.08.007c.264.022.53.039.794.06.4.031.809.063,1.214.091.305.021.612.038.917.057.392.024.783.05,1.176.072.314.017.628.03.942.046.385.018.769.038,1.154.053.32.013.641.022.961.033.38.013.759.027,1.139.037l.2.006c.236.006.471.008.707.012.413.009.825.017,1.239.022.312,0,.624,0,.936.007.4,0,.806,0,1.209,0,.318,0,.636,0,.953-.007q.6-.005,1.191-.014.482-.008.964-.02.591-.014,1.182-.032l.457-.012c.156-.005.311-.014.466-.02q.7-.026,1.4-.059c.29-.013.581-.027.871-.042.492-.026.983-.055,1.474-.086.259-.016.518-.031.776-.048q.933-.063,1.865-.139l.375-.029q1.116-.093,2.229-.2l.113-.01c.12-.012.239-.027.358-.039q1.029-.1,2.054-.224l.746-.089q.994-.121,1.983-.256l.527-.071q1.226-.172,2.445-.365c.2-.031.394-.065.59-.1q.954-.155,1.9-.323c.133-.024.268-.044.4-.068s.272-.052.408-.077q.56-.1,1.117-.211c.31-.06.62-.119.929-.181.373-.074.745-.151,1.117-.229.3-.063.61-.127.914-.193.375-.081.75-.165,1.124-.25.3-.067.595-.133.891-.2.381-.089.76-.181,1.138-.273.287-.07.574-.138.86-.21.391-.1.78-.2,1.169-.3.271-.071.542-.139.812-.212.417-.112.831-.228,1.246-.344.238-.067.478-.131.716-.2.506-.145,1.009-.295,1.511-.446.144-.043.289-.084.432-.128q.967-.295,1.922-.6l.03-.009.135-.045q1.059-.345,2.1-.71c.218-.076.435-.153.652-.23q.869-.309,1.728-.63c.182-.068.366-.135.548-.2q1.094-.416,2.171-.853c.146-.059.289-.121.435-.181q.875-.361,1.739-.736.316-.137.631-.276.885-.392,1.755-.8c.121-.056.244-.111.365-.168q1.033-.488,2.044-1c.176-.088.349-.179.524-.269q.78-.4,1.547-.81c.191-.1.382-.2.571-.308.66-.36,1.315-.725,1.96-1.1q.532-.309,1.053-.622c.08-.048.157-.1.236-.146.271-.164.537-.33.8-.5.24-.149.48-.3.716-.448.263-.168.521-.338.78-.507.23-.151.462-.3.689-.455.255-.172.505-.345.756-.518.221-.153.445-.306.663-.46.248-.175.49-.353.733-.53.212-.154.426-.308.635-.464.24-.179.475-.36.71-.541.2-.156.408-.311.608-.468.233-.184.46-.369.689-.554.193-.156.389-.312.579-.47.227-.188.448-.379.67-.569.183-.156.368-.312.548-.469.222-.194.437-.391.654-.587.151-.137.307-.272.456-.409l.074-.069.171-.161q.426-.4.836-.8l.229-.224q.47-.464.922-.932l.15-.158q.39-.409.767-.821l.21-.23q.427-.475.837-.953l.129-.154q.355-.419.7-.843l.191-.237c.046-.058.094-.115.139-.173q.3-.384.591-.77l.124-.167c.247-.332.49-.665.724-1l.039-.057q.345-.494.67-.992l.087-.133q.321-.494.622-.991l.113-.186c.171-.286.34-.572.5-.86.017-.031.033-.062.05-.093.135-.24.262-.482.391-.723.082-.153.167-.306.245-.46.142-.275.275-.552.407-.828.058-.121.12-.241.177-.362q.279-.6.532-1.2c.025-.059.046-.118.071-.177.141-.341.279-.682.408-1.025l.017-.041c.055-.148.1-.3.157-.446.084-.234.17-.467.248-.7.057-.172.108-.345.162-.517.071-.226.144-.451.209-.677.052-.178.1-.357.146-.536.06-.221.121-.441.175-.662.045-.182.084-.365.126-.547.05-.218.1-.436.145-.655.008-.038.018-.077.026-.115.029-.144.051-.287.077-.431.041-.221.083-.443.119-.665.03-.185.055-.369.081-.554.031-.22.063-.439.089-.659.022-.187.04-.373.059-.56.022-.218.044-.437.061-.655.015-.188.025-.376.036-.565.013-.217.025-.434.033-.651,0-.07.009-.14.011-.21q.011-.379.012-.758l.03-10.495C1809.5,1095.261,1809.492,1095.584,1809.481,1095.906Z",
    transform: "translate(-1636.901 -1044.711)",
    fill: "#91bed4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72472",
    "data-name": "Path 72472",
    d: "M1784.13,893.113c33.807,19.518,33.985,51.164.4,70.682s-88.221,19.519-122.028,0-33.985-51.164-.4-70.683S1750.323,873.594,1784.13,893.113Z",
    transform: "translate(-1637 -878.474)",
    fill: "#d9e8f5"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40276",
    "data-name": "Group 40276",
    transform: "translate(41.7 45.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72473",
    "data-name": "Path 72473",
    d: "M1754.08,958.742a22.907,22.907,0,0,0-4.3-2.121l-4.236-2.406s3-.16,3.31-.939c.1-.28-.4-.878-.674-1.027a17.879,17.879,0,0,0-3.476-.889l-3.7-.633c-1.187-.19-2.59-1.027-3.763-1.313-.913-.225-3.827-.8-3.827-.8l-.084-.061-2.912,5.186.544.292.29,1.231c.046,1.032,2.372,2.007,2.372,2.007.936.476,1.528.881,2.167,1.24,1.67.932,4.916,2.747,5.036,2.8.155.083,2.986,2.306,4.068,2.972.352.221,1.3.66,1.639.424.24-.163.171-.86.054-1.122a13.327,13.327,0,0,0-1.119-1.776,22.59,22.59,0,0,0,3.806,2.653,1.156,1.156,0,0,0,.857-.1,1.2,1.2,0,0,0,.141-1.012,13.02,13.02,0,0,0-3-2.676c1.17.765,4.046,2.576,5.335,2.67a1.067,1.067,0,0,0,.777-.444c.116-.377-.358-1.191-.637-1.476a37.581,37.581,0,0,0-3.9-2.814c.37.187,3.67,1.886,4.911,1.776a1.138,1.138,0,0,0,.709-.6A1.459,1.459,0,0,0,1754.08,958.742Z",
    transform: "translate(-1705.17 -903.556)",
    fill: "#e9b89b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72474",
    "data-name": "Path 72474",
    d: "M1620.772,784.484a15.589,15.589,0,0,0,9.525,14.483l.036.015,4.928,2.079h0l4.276,1.8,10.653,6.027,4.175-10.725c-.411-.346-.843-.688-1.29-1.03-.108-.087-.216-.166-.324-.249-7.465-5.638-18.82-10.747-18.82-10.747a96.315,96.315,0,0,0,.7-14.706c-.494-13.586-4.521-18.125-4.655-18.273l0,0-.612.465a16.124,16.124,0,0,0-5.307,6.939c-.079.191-.148.382-.216.573C1621.435,768.013,1620.826,777.344,1620.772,784.484Z",
    transform: "translate(-1620.771 -753.159)",
    fill: "#2f2f2f"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40281",
    "data-name": "Group 40281",
    transform: "translate(138.342 106.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40278",
    "data-name": "Group 40278",
    transform: "translate(3.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40277",
    "data-name": "Group 40277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72475",
    "data-name": "Path 72475",
    d: "M2089.986,1028.958l-15.446,8.918-20-11.547,15.446-8.918Z",
    transform: "translate(-2054.54 -1017.411)",
    fill: "#e6e7e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40280",
    "data-name": "Group 40280",
    transform: "translate(0 0.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40279",
    "data-name": "Group 40279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72476",
    "data-name": "Path 72476",
    d: "M2075.889,1029.618l-15.446,8.918-20-11.547,15.446-8.918Z",
    transform: "translate(-2040.443 -1018.071)",
    fill: "#fff"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40286",
    "data-name": "Group 40286",
    transform: "translate(52.55 108.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40283",
    "data-name": "Group 40283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40282",
    "data-name": "Group 40282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72477",
    "data-name": "Path 72477",
    d: "M1701.748,1040.839l-14.756,8.519-19.106-11.031,14.756-8.519Z",
    transform: "translate(-1667.885 -1029.807)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40285",
    "data-name": "Group 40285",
    transform: "translate(1.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40284",
    "data-name": "Group 40284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72478",
    "data-name": "Path 72478",
    d: "M1709.836,1040.839l-14.756,8.519-19.106-11.031,14.756-8.519Z",
    transform: "translate(-1675.974 -1029.807)",
    fill: "#fff"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40291",
    "data-name": "Group 40291",
    transform: "translate(162.084 95.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40288",
    "data-name": "Group 40288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40287",
    "data-name": "Group 40287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72479",
    "data-name": "Path 72479",
    d: "M2177.407,984.3l-14.756,8.519-19.106-11.031,14.756-8.519Z",
    transform: "translate(-2143.545 -973.267)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40290",
    "data-name": "Group 40290",
    transform: "translate(1.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40289",
    "data-name": "Group 40289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72480",
    "data-name": "Path 72480",
    d: "M2185.5,984.3l-14.756,8.519-19.106-11.031,14.756-8.519Z",
    transform: "translate(-2151.633 -973.267)",
    fill: "#fff"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40294",
    "data-name": "Group 40294",
    transform: "translate(138.276 76.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72481",
    "data-name": "Path 72481",
    d: "M2199.5,1054.372a18.233,18.233,0,0,0-5.793-6.846c-1.9.39-3.311.225-3.6-.429-.188-.43.152-.976.462-1.477a6.456,6.456,0,0,1,2.892-2.429c-1.159-1.4-1.577-2.789-1.059-3.539a1.382,1.382,0,0,1,.712-.5c.6-.215,1.789.1,4.9,3.045,4.8,4.546,8.116,7.214,8.116,7.214Z",
    transform: "translate(-2155.535 -1005.077)",
    fill: "#ffc9b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72482",
    "data-name": "Path 72482",
    d: "M2226.731,1038.26a22.606,22.606,0,0,0-4.906,3.062,24.058,24.058,0,0,0-2.918,5.129,25.5,25.5,0,0,0,49.305,2.16c.316-.934,2.44-7.571-1.458-13.612-.658-1.02-4.469-6.643-10.776-6.644a11.718,11.718,0,0,0-6.968,2.431c-4.48,3.414-6.222,10.03-4.766,16.9Z",
    transform: "translate(-2177.745 -996.806)",
    fill: "#174664",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72483",
    "data-name": "Path 72483",
    d: "M2256.542,1118.194a22.7,22.7,0,0,0,5.347-4.7c7.457-9.074,2.543-18.871,4.424-38.756,1.5-15.908,6.381-22.491,1.528-30.646-4.385-7.37-8.906-10.5-16.839-8.144s-13.367,9.276-13.367,9.276-12.823,4.854-16.522,14.087c0,0,3.891,29.193,4.046,31.25.63,8.367-3.708,14.517-.178,21.066,3.445,6.392,10.358,8.639,11.955,9.158C2246.949,1124.042,2255.412,1118.906,2256.542,1118.194Z",
    transform: "translate(-2179.443 -1002.057)",
    fill: "#003354",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72484",
    "data-name": "Path 72484",
    d: "M2040.157,1125.619l8.994-.9,15.41,16.594-8.994.9-15.41-16.594Z",
    transform: "translate(-2040.157 -1070.978)",
    fill: "#033059",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72485",
    "data-name": "Path 72485",
    d: "M2048.953,1130.707a.558.558,0,0,1,.354-.936l6.586-.659a.558.558,0,0,1,.464.176l12.719,13.7a.558.558,0,0,1-.354.935l-6.586.659a.559.559,0,0,1-.465-.175l-12.719-13.7Z",
    transform: "translate(-2046.813 -1074.357)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72486",
    "data-name": "Path 72486",
    d: "M2066.149,1162.634l-3.376-6.7s1.068-4.649.554-4.861a2.388,2.388,0,0,0-1.548,0c-.872.377-3.24,3.1-3.24,3.1s-2.629-3.628-3-3.13-2.2.065.757,6.12c2.9,5.943,4.46,9.9,4.46,9.9l5.4-4.423Z",
    transform: "translate(-2051.301 -1091.16)",
    fill: "#ffc9b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72487",
    "data-name": "Path 72487",
    d: "M2079.412,1115.642a22.594,22.594,0,0,0-4.906,3.062,24.043,24.043,0,0,0-2.918,5.129s19.933,21.338,24.169,20.156c9-2.51,20.809-14.461,28.094-40.406,0,0,2.744-11.312-7.775-8.284,0,0-12.584,3.921-19.15,29.767l-17.514-9.425Z",
    transform: "translate(-2064.35 -1047.937)",
    fill: "#003354",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40293",
    "data-name": "Group 40293",
    transform: "translate(44.903 8.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72488",
    "data-name": "Path 72488",
    d: "M2264.518,957.449s-4.1-4.532-4.93-8.227-14.616-21.473-14.616-21.473l-7.9.036s-4.269,18.131-.086,22.718,3.317,3.776,8.958,3.443c0,0,2.734,5.238,1.765,9.99,0,0,8.613.5,9.307.507s7.5-6.995,7.5-6.995Z",
    transform: "translate(-2235.153 -927.75)",
    fill: "#ffc9b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40292",
    "data-name": "Group 40292",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72489",
    "data-name": "Path 72489",
    d: "M2267.822,1009.331l3.273-3.6s13.294.952,13.591-7.85,8.992,5.555,8.992,5.555L2288,1022.248l-17.231-.319-2.947-12.6Z",
    transform: "translate(-2260.299 -979.532)",
    fill: "#e7b6a4",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_72491",
    "data-name": "Path 72491",
    d: "M2289.782,1049.7l-.083,3.1s5.974,3.946,12.389.507c4.514-2.42,4.415-7.619,4.415-7.619l-2.537-2.49s-1.763,4.633-4.091,5.523-8.59,1.089-10.093.984Z",
    transform: "translate(-2232.235 -1008.229)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72492",
    "data-name": "Path 72492",
    d: "M2256.624,924.342a2.324,2.324,0,0,0,1.776-1.336c1.54-3.349,5.482-12.858,4.08-20.062a17.685,17.685,0,0,0-2.2-5.579c-2.215-3.639-4.955-4.862-5.9-4.89a2.169,2.169,0,0,1-2.026-.443,3.612,3.612,0,0,0-4.04-.144,2.406,2.406,0,0,1-2.256.117h0a2.291,2.291,0,0,0-.453-.15,12.3,12.3,0,0,0-13.56,6.292,2.3,2.3,0,0,0-.114,2.049,4.67,4.67,0,0,0,3.5,2.585,2.337,2.337,0,0,1,1.724,1.623c.667,2.277,2.132,6.511,3.883,6.8,2.4.392,2.6-2.056,4.152.817a4.706,4.706,0,0,1,.459,4.044,2.359,2.359,0,0,0-.074,1.591,9.956,9.956,0,0,0,3.483,4.922A10.191,10.191,0,0,0,2256.624,924.342Z",
    transform: "translate(-2187.628 -891.344)",
    fillRule: "evenodd"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72493",
    "data-name": "Path 72493",
    d: "M2167.059,1310.447c-.259-.149-.511-.141-.653.05-2.677,3.588-5.2,7.364-7.608,11.282s-4.676,8-6.793,12.259a113.436,113.436,0,0,0-5.724,13.486,72.7,72.7,0,0,0-2.164,7.5,49.7,49.7,0,0,0-1.068,6.671q-10.7-6.595-21.406-12.957-3.711-2.2-7.427-4.35-2.041-1.178-4.085-2.333c-1.922-1.086-3.847-2.151-5.787-3.174-.969-.51-1.942-1.008-2.929-1.482-.5-.232-.993-.467-1.509-.681-.26-.107-.518-.213-.8-.308a6.165,6.165,0,0,0-.93-.257.9.9,0,0,0-.623.083c-.478.27-.486,1.17-.4,1.687a3.523,3.523,0,0,0,1.435,2.094c.958.758,1.634.791,3.156,1.382.467.182,1.289.6,2.932,1.443.881.451,2.569,1.326,5.478,2.955,1.431.8,2.591,1.47,4.046,2.311q3.688,2.13,7.384,4.325,11.444,6.787,22.893,13.874l1.647.951.037-1.791a46.734,46.734,0,0,1,.9-8.008,73.806,73.806,0,0,1,1.891-7.423,117.329,117.329,0,0,1,5.229-13.665c1.961-4.351,4.089-8.54,6.347-12.579s4.641-7.948,7.174-11.666a1.283,1.283,0,0,0-.286-1.351A1.359,1.359,0,0,0,2167.059,1310.447Z",
    transform: "translate(-1945.723 -1136.863)",
    fill: "#f8d5aa"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72494",
    "data-name": "Path 72494",
    d: "M2376.606,1198.417a.674.674,0,0,0,.02-.094c0-.018,0-.037,0-.057a.819.819,0,0,0,0-.1c0-.021,0-.041,0-.062s0-.026,0-.04c0-.034-.01-.069-.018-.1v0h0c-.006-.029-.013-.058-.021-.087s-.015-.052-.024-.078a.148.148,0,0,0-.005-.015l0-.012c-.005-.015-.01-.03-.016-.046s-.018-.045-.028-.068-.019-.043-.03-.065h0v0c-.01-.021-.02-.041-.031-.061s-.023-.042-.036-.063l-.034-.056,0,0,0,0c-.014-.022-.029-.044-.044-.066s-.034-.047-.052-.069l-.026-.033-.033-.039c-.027-.031-.054-.06-.082-.087s-.029-.025-.044-.039l-.042-.036a1.2,1.2,0,0,0-.164-.119.907.907,0,0,0-.106-.052l-.029-.01-.027-.01-.033-.011a.616.616,0,0,0-.067-.015l-.021,0h-.012l-.023,0a.435.435,0,0,0-.051,0l-.046.005h-.009l-.034.008-.04.014-.038.018,0,0L2330.356,1223a.369.369,0,0,1,.115-.042h0a.458.458,0,0,1,.125,0h.012a.619.619,0,0,1,.122.028l.027.009a.886.886,0,0,1,.135.063,1.183,1.183,0,0,1,.164.119l.042.037a1.573,1.573,0,0,1,.158.165,1.818,1.818,0,0,1,.124.172l0,0a1.888,1.888,0,0,1,.1.179h0a1.721,1.721,0,0,1,.075.181l0,.011a1.538,1.538,0,0,1,.05.181v0a1.247,1.247,0,0,1,.021.145c0,.021,0,.042,0,.063s0,.066,0,.1,0,.038,0,.057a.709.709,0,0,1-.02.094c0,.015-.007.03-.011.044a.513.513,0,0,1-.058.118c-2.533,3.718-4.916,7.623-7.174,11.666s-4.387,8.228-6.347,12.579a117.231,117.231,0,0,0-5.229,13.665,73.809,73.809,0,0,0-1.891,7.423,46.731,46.731,0,0,0-.9,8.008l-.037,1.791,44.991-26.146.037-1.791a46.662,46.662,0,0,1,.9-8.008,73.647,73.647,0,0,1,1.891-7.423,117.364,117.364,0,0,1,5.228-13.665c1.96-4.352,4.089-8.54,6.347-12.579s4.641-7.948,7.174-11.666a.494.494,0,0,0,.058-.118C2376.6,1198.446,2376.6,1198.431,2376.606,1198.417Z",
    transform: "translate(-2109.56 -1049.469)",
    fill: "#c39045"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40317",
    "data-name": "Group 40317",
    transform: "translate(80.911 87.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72495",
    "data-name": "Path 72495",
    d: "M1791.046,981.189l.7.406,18.8,10.908,25.446-14.73.7-.4-19.5-11.314Z",
    transform: "translate(-1791.046 -959.462)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72496",
    "data-name": "Path 72496",
    d: "M1791.046,1031.773v.813l19.5,11.314v-.813l-18.8-10.908Z",
    transform: "translate(-1791.046 -1010.047)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72497",
    "data-name": "Path 72497",
    d: "M1875.736,1030.322v.813L1901.882,1016v-.81l-.7.4Z",
    transform: "translate(-1856.234 -997.281)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40315",
    "data-name": "Group 40315",
    transform: "translate(7.89 10.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40295",
    "data-name": "Group 40295",
    transform: "translate(7.015 4.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72498",
    "data-name": "Path 72498",
    d: "M1858.261,1008.859l1.034.6,10.527-6.078-1.034-.6Z",
    transform: "translate(-1857.688 -1002.451)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72499",
    "data-name": "Path 72499",
    d: "M1857.38,1008.682l-1.607-.927,11.1-6.408,1.607.927Zm-.461-.927.461.266,9.954-5.747-.461-.266Z",
    transform: "translate(-1855.773 -1001.347)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40296",
    "data-name": "Group 40296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72500",
    "data-name": "Path 72500",
    d: "M1827.795,999.371l5.169,2.984,24.558-14.179-5.169-2.984-7.016,4.051,1.034.6-10.527,6.078-1.034-.6Z",
    transform: "translate(-1827.222 -984.862)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72501",
    "data-name": "Path 72501",
    d: "M1831.051,1001.581l-5.742-3.315,7.588-4.381,1.034.6,9.954-5.747-1.034-.6,7.589-4.381,5.742,3.315Zm-4.6-3.315,4.6,2.654,23.986-13.848-4.6-2.654-6.443,3.72,1.034.6-11.1,6.408-1.034-.6Z",
    transform: "translate(-1825.309 -983.757)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40297",
    "data-name": "Group 40297",
    transform: "translate(4.565 2.468)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 24.56,
    y2: 14.18,
    transform: "translate(0.142 0.25)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23504",
    "data-name": "Rectangle 23504",
    width: 28.359,
    height: 0.573,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 14.183)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40298",
    "data-name": "Group 40298",
    transform: "translate(3.531 1.871)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 24.56,
    y2: 14.18,
    transform: "translate(0.143 0.249)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23505",
    "data-name": "Rectangle 23505",
    width: 28.359,
    height: 0.573,
    transform: "translate(0 14.182) rotate(-30.006)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40299",
    "data-name": "Group 40299",
    transform: "translate(2.497 1.274)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 24.56,
    y2: 14.18,
    transform: "translate(0.142 0.25)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23506",
    "data-name": "Rectangle 23506",
    width: 28.359,
    height: 0.573,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 14.183)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40300",
    "data-name": "Group 40300",
    transform: "translate(1.463 10.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72502",
    "data-name": "Path 72502",
    d: "M1832.285,1035.817l1.753-1.012,1.753-1.012,1.755-1.014,1.753-1.012",
    transform: "translate(-1832.142 -1031.518)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23507",
    "data-name": "Rectangle 23507",
    width: 8.101,
    height: 0.573,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 4.052)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40301",
    "data-name": "Group 40301",
    transform: "translate(19.006 0.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72503",
    "data-name": "Path 72503",
    d: "M1908.465,991.835l1.753-1.012,1.755-1.014,1.754-1.012,1.753-1.012",
    transform: "translate(-1908.322 -987.536)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23508",
    "data-name": "Rectangle 23508",
    width: 8.101,
    height: 0.573,
    transform: "translate(0 4.051) rotate(-30.006)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40302",
    "data-name": "Group 40302",
    transform: "translate(2.183 13.249)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23509",
    "data-name": "Rectangle 23509",
    width: 0.573,
    height: 5.969,
    transform: "translate(0 0.496) rotate(-60.001)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40303",
    "data-name": "Group 40303",
    transform: "translate(3.937 12.236)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23510",
    "data-name": "Rectangle 23510",
    width: 0.573,
    height: 5.969,
    transform: "translate(0 0.496) rotate(-59.999)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40304",
    "data-name": "Group 40304",
    transform: "translate(5.691 11.223)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23511",
    "data-name": "Rectangle 23511",
    width: 0.573,
    height: 5.969,
    transform: "translate(0 0.496) rotate(-59.999)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40305",
    "data-name": "Group 40305",
    transform: "translate(8.479 10.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72504",
    "data-name": "Path 72504",
    d: "M1866.886,1034.154l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1862.608 -1031.519)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23512",
    "data-name": "Rectangle 23512",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40306",
    "data-name": "Group 40306",
    transform: "translate(10.234 9.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72505",
    "data-name": "Path 72505",
    d: "M1874.51,1029.753l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1870.231 -1027.117)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23513",
    "data-name": "Rectangle 23513",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40307",
    "data-name": "Group 40307",
    transform: "translate(11.988 8.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72506",
    "data-name": "Path 72506",
    d: "M1882.124,1025.357l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1877.845 -1022.721)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23514",
    "data-name": "Rectangle 23514",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40308",
    "data-name": "Group 40308",
    transform: "translate(13.741 7.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72507",
    "data-name": "Path 72507",
    d: "M1889.738,1020.961l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1885.46 -1018.325)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23515",
    "data-name": "Rectangle 23515",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40309",
    "data-name": "Group 40309",
    transform: "translate(15.497 6.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72508",
    "data-name": "Path 72508",
    d: "M1897.362,1016.559l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1893.083 -1013.924)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23516",
    "data-name": "Rectangle 23516",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40310",
    "data-name": "Group 40310",
    transform: "translate(17.25 5.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72509",
    "data-name": "Path 72509",
    d: "M1904.976,1012.163l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1900.698 -1009.528)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23517",
    "data-name": "Rectangle 23517",
    width: 0.573,
    height: 4.775,
    transform: "translate(0 0.496) rotate(-59.998)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40311",
    "data-name": "Group 40311",
    transform: "translate(19.006 4.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72510",
    "data-name": "Path 72510",
    d: "M1912.6,1007.762l-1.034-.6-1.034-.6-1.034-.6-1.034-.6",
    transform: "translate(-1908.322 -1005.126)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23518",
    "data-name": "Rectangle 23518",
    width: 0.573,
    height: 4.775,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40312",
    "data-name": "Group 40312",
    transform: "translate(19.726 3.121)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23519",
    "data-name": "Rectangle 23519",
    width: 0.573,
    height: 5.969,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40313",
    "data-name": "Group 40313",
    transform: "translate(21.48 2.108)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23520",
    "data-name": "Rectangle 23520",
    width: 0.573,
    height: 5.969,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40314",
    "data-name": "Group 40314",
    transform: "translate(23.234 1.095)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 5.169,
    y2: 2.984,
    transform: "translate(0.143 0.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23521",
    "data-name": "Rectangle 23521",
    width: 0.573,
    height: 5.969,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 0.496)",
    fill: "#666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40316",
    "data-name": "Group 40316",
    transform: "translate(9.373 11.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72511",
    "data-name": "Path 72511",
    d: "M1837.628,995.8l8.537-4.929c.244-.141.214-.388-.069-.551l-4.129-2.384a1.06,1.06,0,0,0-.954-.04l-8.537,4.929c-.245.141-.214.388.068.551l4.13,2.384A1.06,1.06,0,0,0,1837.628,995.8Z",
    transform: "translate(-1832.182 -987.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72512",
    "data-name": "Path 72512",
    d: "M1836.781,995.591a1.236,1.236,0,0,1-.6-.152l-4.129-2.384a.516.516,0,0,1-.3-.424.408.408,0,0,1,.23-.351l8.537-4.929a1.187,1.187,0,0,1,1.084.04l4.129,2.384a.517.517,0,0,1,.3.423.409.409,0,0,1-.23.351l-8.537,4.929A.975.975,0,0,1,1836.781,995.591Zm4.213-8.094a.713.713,0,0,0-.348.078l-8.537,4.929c-.038.022-.1.067-.1.127s.064.14.169.2l4.129,2.384a.931.931,0,0,0,.824.04l8.537-4.929c.038-.022.1-.067.1-.128s-.065-.139-.169-.2l-4.129-2.384A.984.984,0,0,0,1840.994,987.5Z",
    transform: "translate(-1831.75 -987.238)",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72513",
    "data-name": "Path 72513",
    d: "M1888.021,950.338l.96,4.254-1.639.869-1.06-4.022a6.27,6.27,0,0,0-.621-1.506l-.414-.712a.422.422,0,0,0-.72-.017,5.533,5.533,0,0,0-.621,1.324,4.981,4.981,0,0,0-.215,1.448l-.009.761a1.385,1.385,0,0,1-.265.794.415.415,0,0,1-.323.166.41.41,0,0,1-.356-.207,2.543,2.543,0,0,1-.273-.836l-.232-1.838a6.342,6.342,0,0,1,.025-1.771l.174-1.217a3.916,3.916,0,0,0,.066-1.945,5.457,5.457,0,0,0-.993-1.845,5.892,5.892,0,0,1-.323-.53,22.049,22.049,0,0,0,3.278-1.647,20.22,20.22,0,0,0,2.036-1.407l1.217,1.407.637.488a20.871,20.871,0,0,1,3.36,3.145l3.253,3.8-3.551,3.17L1888.4,950.1A.238.238,0,0,0,1888.021,950.338Z",
    transform: "translate(-1860.428 -939.758)",
    fill: "#efc7b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72514",
    "data-name": "Path 72514",
    d: "M1875.736,954.835v17.383l13.232-7.659.041-.023,12.874-7.452V939.7l-.895.519L1876.1,954.628l-.01.005Z",
    transform: "translate(-1856.234 -939.177)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72515",
    "data-name": "Path 72515",
    d: "M1871.85,952.559l.895.524L1898,938.468l.895-.519-.895-.524Z",
    transform: "translate(-1853.243 -937.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72516",
    "data-name": "Path 72516",
    d: "M1871.85,1003.144v17.383l.895.524v-17.383Z",
    transform: "translate(-1853.243 -988.01)",
    fill: "#b3b3b3"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72517",
    "data-name": "Path 72517",
    d: "M1802.191,762.732c-.332.295-.7.59-1.1.9a22.4,22.4,0,0,1-2.269,1.568,24.234,24.234,0,0,1-3.654,1.836c-.362.149-.7.276-1.034.388a28.075,28.075,0,0,1-5.188-2.964c-.87-.627-1.78-1.362-6.08-5.923-4.669-4.953-5.584-6.192-5.856-7.95a21.9,21.9,0,0,1-.22-3.344c.011-1.683.2-1.874.235-3.5.037-1.766-.213-2.154-.284-4.46-.037-1.168-.045-2.445-.011-3.818a57.872,57.872,0,0,0-.433-7.133,28.073,28.073,0,0,0-2.631-10.145,19.447,19.447,0,0,0-5.378-6.3,2.605,2.605,0,0,0,1.246-.563,2.988,2.988,0,0,0,.825-1.441c.045-.134.09-.272.127-.414a21.927,21.927,0,0,1,5.386,3.99c4.188,4.285,4.531,8.924,7.647,19.6.777,2.646,2,6.607,3.7,11.432a21.876,21.876,0,0,0,3.046,6.248c1.441,2.03,2.721,3.064,5.345,5.509C1797.2,757.719,1799.485,759.906,1802.191,762.732Z",
    transform: "translate(-1692.617 -674.349)",
    fill: "#2f2f2f"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40414",
    "data-name": "Group 40414",
    transform: "translate(81.119 128.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40319",
    "data-name": "Group 40319",
    transform: "translate(1.846 0.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40318",
    "data-name": "Group 40318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72518",
    "data-name": "Path 72518",
    d: "M1854.768,1134.186l-23.88,13.787-30.921-17.852,23.88-13.787Z",
    transform: "translate(-1799.966 -1116.333)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40321",
    "data-name": "Group 40321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40320",
    "data-name": "Group 40320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72519",
    "data-name": "Path 72519",
    d: "M1846.752,1133.866l-23.88,13.787-30.921-17.852,23.88-13.787Z",
    transform: "translate(-1791.951 -1116.013)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40323",
    "data-name": "Group 40323",
    transform: "translate(1.449 4.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40322",
    "data-name": "Group 40322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72520",
    "data-name": "Path 72520",
    d: "M1819.368,1140.941l-15.021,8.672-6.1-3.523,15.021-8.672Z",
    transform: "translate(-1798.245 -1137.418)",
    fill: "#d9e8f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40325",
    "data-name": "Group 40325",
    transform: "translate(8.892 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40324",
    "data-name": "Group 40324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72521",
    "data-name": "Path 72521",
    d: "M1846.439,1169.608l-11.04,6.374-4.835-2.792,11.04-6.374Zm-11.04,6.024,10.434-6.024-4.23-2.442-10.434,6.024Z",
    transform: "translate(-1830.563 -1166.816)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40348",
    "data-name": "Group 40348",
    transform: "translate(3.869 6.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40327",
    "data-name": "Group 40327",
    transform: "translate(0 7.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40326",
    "data-name": "Group 40326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72522",
    "data-name": "Path 72522",
    d: "M1811.235,1176.36l-1.977-1.141c-.5-.288-.647-.6-.354-.772a1.5,1.5,0,0,1,1.338.2l.418.241-.309.178-.417-.241a.579.579,0,0,0-.517-.09c-.107.062-.053.178.156.3l1.977,1.142a.578.578,0,0,0,.517.09c.107-.061.053-.178-.155-.3l-.51-.294.308-.178.51.294c.5.288.647.6.354.772A1.5,1.5,0,0,1,1811.235,1176.36Z",
    transform: "translate(-1808.754 -1174.359)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40329",
    "data-name": "Group 40329",
    transform: "translate(0.98 6.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40328",
    "data-name": "Group 40328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72523",
    "data-name": "Path 72523",
    d: "M1817.282,1173.313l-1.7-.719-.163.094,1.473.851-.314.181-3.567-2.059.492-.284a1.475,1.475,0,0,1,1.343.208l.392.227c.331.191.506.384.513.545l1.859.769Zm-2.373-.918.163-.094c.122-.07.07-.182-.139-.3l-.413-.238a.554.554,0,0,0-.524-.08l-.163.094Z",
    transform: "translate(-1813.01 -1171.288)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40331",
    "data-name": "Group 40331",
    transform: "translate(2.269 5.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40330",
    "data-name": "Group 40330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72524",
    "data-name": "Path 72524",
    d: "M1818.607,1167.956l.892-.515.51.294-.578.334.994.574.459-.265.51.294-.459.265,1.045.6.578-.334.51.294-.892.515Z",
    transform: "translate(-1818.607 -1167.441)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40333",
    "data-name": "Group 40333",
    transform: "translate(3.424 5.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40332",
    "data-name": "Group 40332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72525",
    "data-name": "Path 72525",
    d: "M1823.625,1165.532l.492-.284a1.475,1.475,0,0,1,1.343.207l1.865,1.077c.515.3.658.6.359.775l-.492.284Zm3.534,1.49c.122-.07.07-.182-.138-.3l-1.885-1.089a.555.555,0,0,0-.524-.08l-.163.094,2.548,1.471Z",
    transform: "translate(-1823.625 -1165.159)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40335",
    "data-name": "Group 40335",
    transform: "translate(4.722 4.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40334",
    "data-name": "Group 40334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72526",
    "data-name": "Path 72526",
    d: "M1829.261,1162.92l.314-.181,3.567,2.059-.314.181Z",
    transform: "translate(-1829.261 -1162.739)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40337",
    "data-name": "Group 40337",
    transform: "translate(5.279 3.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40336",
    "data-name": "Group 40336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72527",
    "data-name": "Path 72527",
    d: "M1831.679,1160.2l1-.578.51.294-.344.2,3.058,1.765-.314.181-3.057-1.765-.344.2Z",
    transform: "translate(-1831.679 -1159.619)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40339",
    "data-name": "Group 40339",
    transform: "translate(7.342 3.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40338",
    "data-name": "Group 40338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72528",
    "data-name": "Path 72528",
    d: "M1843.081,1157.948l-.127-.074.246-.207.133.076a.706.706,0,0,0,.619.125c.125-.072.069-.193-.14-.314a2.651,2.651,0,0,0-1.057-.278,3.866,3.866,0,0,1-1.572-.446c-.53-.306-.7-.609-.4-.781a1.5,1.5,0,0,1,1.359.234l.092.053-.246.207-.1-.059c-.276-.159-.48-.205-.59-.142s-.054.167.17.3a2.847,2.847,0,0,0,1.057.278,4.068,4.068,0,0,1,1.572.446c.51.294.669.626.37.8A1.571,1.571,0,0,1,1843.081,1157.948Z",
    transform: "translate(-1840.636 -1155.965)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40341",
    "data-name": "Group 40341",
    transform: "translate(8.59 2.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40340",
    "data-name": "Group 40340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72529",
    "data-name": "Path 72529",
    d: "M1848.536,1154.824l-1.977-1.142c-.5-.288-.647-.6-.354-.772a1.5,1.5,0,0,1,1.338.2l.418.241-.308.178-.418-.241a.58.58,0,0,0-.517-.09c-.106.062-.053.178.156.3l1.977,1.141a.58.58,0,0,0,.517.09c.107-.062.053-.178-.156-.3l-.51-.294.308-.178.51.294c.5.289.647.6.354.773A1.5,1.5,0,0,1,1848.536,1154.824Z",
    transform: "translate(-1846.055 -1152.823)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40343",
    "data-name": "Group 40343",
    transform: "translate(9.851 1.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40342",
    "data-name": "Group 40342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72530",
    "data-name": "Path 72530",
    d: "M1853.994,1151.63l-1.947-1.124c-.515-.3-.66-.614-.358-.788a1.514,1.514,0,0,1,1.365.207l1.947,1.124c.515.3.66.613.357.788A1.513,1.513,0,0,1,1853.994,1151.63Zm.693-.4-1.947-1.124a.59.59,0,0,0-.541-.094c-.116.067-.062.183.162.313l1.947,1.124a.589.589,0,0,0,.541.094C1854.965,1151.475,1854.912,1151.359,1854.687,1151.229Z",
    transform: "translate(-1851.533 -1149.628)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40345",
    "data-name": "Group 40345",
    transform: "translate(10.879 0.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40344",
    "data-name": "Group 40344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72531",
    "data-name": "Path 72531",
    d: "M1860.27,1148.494l-1.7-.719-.163.094,1.473.85-.314.181-3.567-2.06.492-.284a1.475,1.475,0,0,1,1.343.208l.392.227c.332.191.506.384.513.545l1.858.769Zm-2.373-.919.163-.094c.122-.07.07-.182-.138-.3l-.413-.238a.554.554,0,0,0-.524-.08l-.163.094Z",
    transform: "translate(-1855.998 -1146.469)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40347",
    "data-name": "Group 40347",
    transform: "translate(12.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40346",
    "data-name": "Group 40346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72532",
    "data-name": "Path 72532",
    d: "M1861.595,1143.137l.892-.515.51.294-.578.334.994.574.459-.265.51.294-.459.265,1.045.6.578-.334.51.294-.892.515Z",
    transform: "translate(-1861.595 -1142.622)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40350",
    "data-name": "Group 40350",
    transform: "translate(20.423 1.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40349",
    "data-name": "Group 40349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72533",
    "data-name": "Path 72533",
    d: "M1885.059,1120.883l-3.726,2.151a.638.638,0,0,1-.576,0,.176.176,0,0,1,0-.333l3.726-2.151a.636.636,0,0,1,.576,0A.175.175,0,0,1,1885.059,1120.883Z",
    transform: "translate(-1880.638 -1120.482)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40352",
    "data-name": "Group 40352",
    transform: "translate(20.129 2.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40351",
    "data-name": "Group 40351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72534",
    "data-name": "Path 72534",
    d: "M1886.22,1126.252l-6.161,3.557a.636.636,0,0,1-.576,0,.176.176,0,0,1,0-.333l6.161-3.557a.636.636,0,0,1,.576,0A.176.176,0,0,1,1886.22,1126.252Z",
    transform: "translate(-1879.364 -1125.851)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40354",
    "data-name": "Group 40354",
    transform: "translate(23.767 4.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40353",
    "data-name": "Group 40353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72535",
    "data-name": "Path 72535",
    d: "M1902.839,1138.094l-6.982,4.031a.637.637,0,0,1-.576,0,.175.175,0,0,1,0-.333l6.982-4.031a.636.636,0,0,1,.576,0A.176.176,0,0,1,1902.839,1138.094Z",
    transform: "translate(-1895.161 -1137.693)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40356",
    "data-name": "Group 40356",
    transform: "translate(30.042 8.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40355",
    "data-name": "Group 40355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72536",
    "data-name": "Path 72536",
    d: "M1922.41,1152.248",
    transform: "translate(-1922.41 -1152.248)",
    fill: "none",
    stroke: "#0477bf",
    strokeLinecap: "round",
    strokeWidth: 3.361
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40358",
    "data-name": "Group 40358",
    transform: "translate(23.881 11.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40357",
    "data-name": "Group 40357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72537",
    "data-name": "Path 72537",
    d: "M1895.656,1167.694",
    transform: "translate(-1895.656 -1167.694)",
    fill: "none",
    stroke: "#0477bf",
    strokeLinecap: "round",
    strokeWidth: 3.361
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40360",
    "data-name": "Group 40360",
    transform: "translate(22.271 3.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40359",
    "data-name": "Group 40359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72538",
    "data-name": "Path 72538",
    d: "M1895.52,1131.622l-6.161,3.557a.637.637,0,0,1-.576,0,.175.175,0,0,1,0-.333l6.161-3.557a.637.637,0,0,1,.576,0A.176.176,0,0,1,1895.52,1131.622Z",
    transform: "translate(-1888.664 -1131.221)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40367",
    "data-name": "Group 40367",
    transform: "translate(12.51 13.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40362",
    "data-name": "Group 40362",
    transform: "translate(0.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40361",
    "data-name": "Group 40361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72539",
    "data-name": "Path 72539",
    d: "M1853.915,1173.6l-6.437,3.717a.389.389,0,0,1-.351,0,.107.107,0,0,1,0-.2l6.437-3.716a.389.389,0,0,1,.351,0A.107.107,0,0,1,1853.915,1173.6Z",
    transform: "translate(-1847.054 -1173.352)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40364",
    "data-name": "Group 40364",
    transform: "translate(0 0.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40363",
    "data-name": "Group 40363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72540",
    "data-name": "Path 72540",
    d: "M1854.623,1176.869l-7.921,4.573a.389.389,0,0,1-.351,0,.107.107,0,0,1,0-.2l7.921-4.573a.388.388,0,0,1,.351,0A.107.107,0,0,1,1854.623,1176.869Z",
    transform: "translate(-1846.277 -1176.625)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40366",
    "data-name": "Group 40366",
    transform: "translate(1.305 1.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40365",
    "data-name": "Group 40365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72541",
    "data-name": "Path 72541",
    d: "M1860.292,1180.143l-7.921,4.573a.388.388,0,0,1-.351,0,.107.107,0,0,1,0-.2l7.921-4.573a.389.389,0,0,1,.351,0A.107.107,0,0,1,1860.292,1180.143Z",
    transform: "translate(-1851.946 -1179.898)",
    fill: "#0477bf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40369",
    "data-name": "Group 40369",
    transform: "translate(19.621 18.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40368",
    "data-name": "Group 40368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72542",
    "data-name": "Path 72542",
    d: "M1883.279,1195.982l-5.822,3.361-.3-.175,5.822-3.361Z",
    transform: "translate(-1877.154 -1195.807)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40371",
    "data-name": "Group 40371",
    transform: "translate(19.442 19.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40370",
    "data-name": "Group 40370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72543",
    "data-name": "Path 72543",
    d: "M1883.844,1198.9l-7.164,4.136-.3-.175,7.164-4.136Z",
    transform: "translate(-1876.377 -1198.725)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40373",
    "data-name": "Group 40373",
    transform: "translate(20.605 19.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40372",
    "data-name": "Group 40372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72544",
    "data-name": "Path 72544",
    d: "M1888.9,1201.817l-7.164,4.136-.3-.175,7.164-4.136Z",
    transform: "translate(-1881.43 -1201.642)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40375",
    "data-name": "Group 40375",
    transform: "translate(25.994 15.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40374",
    "data-name": "Group 40374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72545",
    "data-name": "Path 72545",
    d: "M1927.317,1181.787l-22.185,12.808-.3-.175,22.185-12.809Z",
    transform: "translate(-1904.829 -1181.612)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40377",
    "data-name": "Group 40377",
    transform: "translate(27.358 15.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40376",
    "data-name": "Group 40376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72546",
    "data-name": "Path 72546",
    d: "M1933.241,1185.207l-22.185,12.808-.3-.175,22.185-12.808Z",
    transform: "translate(-1910.753 -1185.032)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40379",
    "data-name": "Group 40379",
    transform: "translate(28.722 16.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40378",
    "data-name": "Group 40378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72547",
    "data-name": "Path 72547",
    d: "M1939.165,1188.627l-22.185,12.809-.3-.175,22.185-12.808Z",
    transform: "translate(-1916.677 -1188.452)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40381",
    "data-name": "Group 40381",
    transform: "translate(30.086 17.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40380",
    "data-name": "Group 40380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72548",
    "data-name": "Path 72548",
    d: "M1945.089,1192.047l-22.185,12.809-.3-.175,22.185-12.808Z",
    transform: "translate(-1922.601 -1191.873)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40383",
    "data-name": "Group 40383",
    transform: "translate(22.726 5.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40382",
    "data-name": "Group 40382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72549",
    "data-name": "Path 72549",
    d: "M1900.825,1141.549l-9.489,5.479a.636.636,0,0,1-.576,0,.176.176,0,0,1,0-.333l9.489-5.478a.637.637,0,0,1,.576,0A.175.175,0,0,1,1900.825,1141.549Z",
    transform: "translate(-1890.641 -1141.148)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40385",
    "data-name": "Group 40385",
    transform: "translate(24.22 6.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40384",
    "data-name": "Group 40384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72550",
    "data-name": "Path 72550",
    d: "M1907.311,1145.293l-9.489,5.478a.636.636,0,0,1-.576,0,.175.175,0,0,1,0-.333l9.489-5.479a.637.637,0,0,1,.576,0A.176.176,0,0,1,1907.311,1145.293Z",
    transform: "translate(-1897.127 -1144.892)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40387",
    "data-name": "Group 40387",
    transform: "translate(25.713 7.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40386",
    "data-name": "Group 40386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72551",
    "data-name": "Path 72551",
    d: "M1913.8,1149.038l-9.489,5.479a.636.636,0,0,1-.576,0,.176.176,0,0,1,0-.333l9.489-5.478a.636.636,0,0,1,.576,0A.175.175,0,0,1,1913.8,1149.038Z",
    transform: "translate(-1903.613 -1148.637)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40396",
    "data-name": "Group 40396",
    transform: "translate(15.753 9.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40389",
    "data-name": "Group 40389",
    transform: "translate(0 7.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40388",
    "data-name": "Group 40388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72552",
    "data-name": "Path 72552",
    d: "M1875.2,1192.76l-9.159,5.288-5.684-3.282,9.159-5.288Zm-9.159,5,8.666-5-5.19-3-8.666,5Z",
    transform: "translate(-1860.361 -1189.478)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40391",
    "data-name": "Group 40391",
    transform: "translate(8.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40390",
    "data-name": "Group 40390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72553",
    "data-name": "Path 72553",
    d: "M1921.083,1160.81l-13.616,7.861-8.4-4.851,13.616-7.861Zm-13.616,7.576,13.122-7.576-7.909-4.566-13.122,7.576Z",
    transform: "translate(-1899.064 -1155.959)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40393",
    "data-name": "Group 40393",
    transform: "translate(5.437 10.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40392",
    "data-name": "Group 40392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72554",
    "data-name": "Path 72554",
    d: "M1896.1,1204.822l-9.16,5.288-2.966-1.712,9.16-5.288Zm-9.16,5,8.666-5-2.472-1.427-8.666,5Z",
    transform: "translate(-1883.972 -1203.11)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40395",
    "data-name": "Group 40395",
    transform: "translate(9.966 13.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40394",
    "data-name": "Group 40394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72555",
    "data-name": "Path 72555",
    d: "M1906.656,1216.206a.274.274,0,0,1-.247,0l-2.719-1.57a.075.075,0,0,1,0-.143.273.273,0,0,1,.247,0l2.719,1.57A.075.075,0,0,1,1906.656,1216.206Z",
    transform: "translate(-1903.639 -1214.464)",
    fill: "#0477bf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40413",
    "data-name": "Group 40413",
    transform: "translate(30.852 12.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40407",
    "data-name": "Group 40407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40398",
    "data-name": "Group 40398",
    transform: "translate(0 2.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40397",
    "data-name": "Group 40397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72556",
    "data-name": "Path 72556",
    d: "M1928.957,1181.315a1.272,1.272,0,0,0,.2,1.553,2,2,0,0,0,.172.173l-2.436.857a3.544,3.544,0,0,1-.479-.531,2.273,2.273,0,0,1-.084-2.709Z",
    transform: "translate(-1925.927 -1180.659)",
    fill: "#f24c27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40400",
    "data-name": "Group 40400",
    transform: "translate(0.97 4.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40399",
    "data-name": "Group 40399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72557",
    "data-name": "Path 72557",
    d: "M1935.091,1191.914l-.782,1.595a9.467,9.467,0,0,1-2.122-.476,7.052,7.052,0,0,1-1.161-.53,5,5,0,0,1-.886-.641l2.436-.857a2.79,2.79,0,0,0,.467.334,3.888,3.888,0,0,0,.67.3A5.362,5.362,0,0,0,1935.091,1191.914Z",
    transform: "translate(-1930.139 -1191.005)",
    fill: "#0477bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40402",
    "data-name": "Group 40402",
    transform: "translate(4.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40401",
    "data-name": "Group 40401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72558",
    "data-name": "Path 72558",
    d: "M1949.729,1170.979l-1.525,1.392a4.63,4.63,0,0,0-.471-.152,5.9,5.9,0,0,0-2.579-.079l-1.029-1.537a10.8,10.8,0,0,1,4.39.02A8.732,8.732,0,0,1,1949.729,1170.979Z",
    transform: "translate(-1944.125 -1170.387)",
    fill: "#f24c27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40404",
    "data-name": "Group 40404",
    transform: "translate(0.407 0.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40403",
    "data-name": "Group 40403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72559",
    "data-name": "Path 72559",
    d: "M1929.144,1172.179a7.883,7.883,0,0,1,2.334-.856l1.029,1.537a4.379,4.379,0,0,0-1.347.484,2.234,2.234,0,0,0-.843.786l-2.623-.656A4.211,4.211,0,0,1,1929.144,1172.179Z",
    transform: "translate(-1927.695 -1171.323)",
    fill: "#91bed4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40406",
    "data-name": "Group 40406",
    transform: "translate(8.269 0.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40405",
    "data-name": "Group 40405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72560",
    "data-name": "Path 72560",
    d: "M1964.384,1173.437a4.892,4.892,0,0,1,.975.725,3,3,0,0,1,.738,1.089l-2.741.5a1.548,1.548,0,0,0-.432-.73,2.665,2.665,0,0,0-.556-.418,3.769,3.769,0,0,0-.533-.252l1.525-1.392A6.9,6.9,0,0,1,1964.384,1173.437Z",
    transform: "translate(-1961.835 -1172.957)",
    fill: "#91bed4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40412",
    "data-name": "Group 40412",
    transform: "translate(4.359 2.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40409",
    "data-name": "Group 40409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40408",
    "data-name": "Group 40408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72561",
    "data-name": "Path 72561",
    d: "M1947.15,1182.186l-.017-.011a.425.425,0,0,0-.094-.039l-2.184-.982,1.7,1.261a.259.259,0,0,0,.067.054l.019.01.006,0h0a.569.569,0,0,0,.484-.014c.133-.077.14-.2.023-.279h0Z",
    transform: "translate(-1944.855 -1181.155)",
    fill: "#35174c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40411",
    "data-name": "Group 40411",
    transform: "translate(1.945 1.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40410",
    "data-name": "Group 40410"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 0.094,
    cy: 0.054,
    rx: 0.094,
    ry: 0.054,
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40415",
    "data-name": "Group 40415",
    transform: "translate(118.013 72.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72562",
    "data-name": "Path 72562",
    d: "M1959.673,910.418c-2.383,1.092-5.44.941-6.828-.338s-.581-3.2,1.8-4.293,5.44-.94,6.829.338S1962.056,909.326,1959.673,910.418Z",
    transform: "translate(-1952.165 -897.165)",
    fill: "#808285",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72563",
    "data-name": "Path 72563",
    d: "M1964.349,878.015a2.2,2.2,0,0,1-1.154,1.363,6.321,6.321,0,0,1-5.72,0,2.2,2.2,0,0,1-1.154-1.363,1.866,1.866,0,0,1,1.154-1.94,6.324,6.324,0,0,1,5.72,0A1.865,1.865,0,0,1,1964.349,878.015Z",
    transform: "translate(-1955.342 -874.331)",
    fill: "#e9e9e9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72564",
    "data-name": "Path 72564",
    d: "M1966.466,916.524a1.433,1.433,0,0,1-.875,1.353,4.711,4.711,0,0,1-4.261,0,1.613,1.613,0,0,1-.866-1.049h-.011l-.1-1.216a1.374,1.374,0,0,0,.288.424,2.355,2.355,0,0,0,.565.417,4,4,0,0,0,1.024.375,5.709,5.709,0,0,0,2.464,0,4.008,4.008,0,0,0,1.024-.375,2.357,2.357,0,0,0,.565-.417,1.465,1.465,0,0,0,.241-.324Z",
    transform: "translate(-1958.465 -905.288)",
    fill: "#e6e7e8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72565",
    "data-name": "Path 72565",
    d: "M1965.364,891.427l-.338,4.821-.059.848a1.461,1.461,0,0,1-.241.324,2.361,2.361,0,0,1-.565.417,4,4,0,0,1-1.024.375,5.707,5.707,0,0,1-2.464,0,4,4,0,0,1-1.024-.375,2.351,2.351,0,0,1-.565-.417,1.377,1.377,0,0,1-.288-.424l-.052-.622-.413-4.947Z",
    transform: "translate(-1956.909 -886.673)",
    fill: "#bb9e7d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72566",
    "data-name": "Path 72566",
    d: "M1963.2,888.722a6.32,6.32,0,0,1-5.72,0,1.865,1.865,0,0,1-1.154-1.939,2.2,2.2,0,0,0,1.154,1.363,6.321,6.321,0,0,0,5.72,0,2.2,2.2,0,0,0,1.154-1.363A1.865,1.865,0,0,1,1963.2,888.722Z",
    transform: "translate(-1955.342 -883.099)",
    fill: "#d1d3d4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72567",
    "data-name": "Path 72567",
    d: "M1964.452,879.941a2.2,2.2,0,0,1-1.154,1.363,6.321,6.321,0,0,1-5.72,0,1.382,1.382,0,0,1,0-2.725,6.32,6.32,0,0,1,5.72,0A2.2,2.2,0,0,1,1964.452,879.941Z",
    transform: "translate(-1955.444 -876.257)",
    fill: "#e6e7e8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72568",
    "data-name": "Path 72568",
    d: "M1964.19,882.455a5.719,5.719,0,0,1-5.176,0,1.769,1.769,0,0,1-1.069-1.584l-.009-.911h.005a1.288,1.288,0,0,0,.1.5,1.642,1.642,0,0,0,.254.41,2.6,2.6,0,0,0,.715.583,5.719,5.719,0,0,0,5.176,0,2.62,2.62,0,0,0,.713-.581,1.635,1.635,0,0,0,.255-.413,1.308,1.308,0,0,0,.1-.413v.826A1.77,1.77,0,0,1,1964.19,882.455Z",
    transform: "translate(-1956.608 -877.847)",
    fill: "#d2d2d2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72569",
    "data-name": "Path 72569",
    d: "M1965.277,872.81v.174a1.3,1.3,0,0,1-.1.413,1.64,1.64,0,0,1-.255.413,2.619,2.619,0,0,1-.713.581,5.719,5.719,0,0,1-5.176,0,2.6,2.6,0,0,1-.715-.583,1.644,1.644,0,0,1-.254-.41,1.285,1.285,0,0,1-.1-.5,1.819,1.819,0,0,1,1.072-1.494,5.721,5.721,0,0,1,5.176,0A1.871,1.871,0,0,1,1965.277,872.81Z",
    transform: "translate(-1956.625 -870.784)",
    fill: "#ebebeb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72570",
    "data-name": "Path 72570",
    d: "M1978.363,881.893l-.026-.015c-.1-.055-.084-.153.027-.217l.9-.517a.419.419,0,0,1,.376-.016l.026.015c.1.055.083.153-.027.217l-.9.517A.419.419,0,0,1,1978.363,881.893Z",
    transform: "translate(-1972.26 -878.718)",
    fill: "#58595b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40417",
    "data-name": "Group 40417",
    transform: "translate(129.711 151.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72571",
    "data-name": "Path 72571",
    d: "M2015.139,1241.554c-2.774,1.271-6.333,1.095-7.949-.394s-.676-3.726,2.1-5,6.333-1.095,7.949.394S2017.914,1240.283,2015.139,1241.554Z",
    transform: "translate(-2005.608 -1230.126)",
    fill: "#808285",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40416",
    "data-name": "Group 40416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72572",
    "data-name": "Path 72572",
    d: "M2020.878,1239.389a2.583,2.583,0,0,1-1.114,1.27,6.018,6.018,0,0,1-5.875,0,2.588,2.588,0,0,1-1.114-1.27,2.049,2.049,0,0,1,1.114-2.427,6.018,6.018,0,0,1,5.875,0A2.049,2.049,0,0,1,2020.878,1239.389Z",
    transform: "translate(-2010.437 -1230.804)",
    fill: "#3c2415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72573",
    "data-name": "Path 72573",
    d: "M2005.162,1229.923a3.172,3.172,0,0,1-1.417-.9,3.115,3.115,0,0,1-.74-2.425,1.4,1.4,0,0,1,.457-.9,1.358,1.358,0,0,1,1.008-.252q.051.37.1.74a.8.8,0,0,0-.362.11,1.275,1.275,0,0,0-.425,1.236,1.811,1.811,0,0,0,1.055,1.26Z",
    transform: "translate(-2002.963 -1222.523)",
    fill: "#603913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72574",
    "data-name": "Path 72574",
    d: "M2018.937,1228.091c-.2,1.747-.166,3.549-.614,4.6v0a2.162,2.162,0,0,1-.128.254l-.027.044-.031.048a3.028,3.028,0,0,1-1.017.9,7.076,7.076,0,0,1-6.4,0,3.034,3.034,0,0,1-1.016-.9l-.041-.064a3.213,3.213,0,0,1-.207-.459,16.021,16.021,0,0,1-.558-4.422Z",
    transform: "translate(-2007.527 -1224.565)",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72575",
    "data-name": "Path 72575",
    d: "M2011.317,1247.293a3.206,3.206,0,0,0,.207.459,1.881,1.881,0,0,1-.157-.31C2011.348,1247.393,2011.331,1247.343,2011.317,1247.293Z",
    transform: "translate(-2009.393 -1239.346)",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72576",
    "data-name": "Path 72576",
    d: "M2049.413,1248.057a1.819,1.819,0,0,1-.128.254A2.107,2.107,0,0,0,2049.413,1248.057Z",
    transform: "translate(-2038.618 -1239.934)",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72577",
    "data-name": "Path 72577",
    d: "M2013.668,1218.779a7.41,7.41,0,0,1-3.5-.8,2.308,2.308,0,0,1,0-4.391,8.037,8.037,0,0,1,7.006,0,2.308,2.308,0,0,1,0,4.391A7.41,7.41,0,0,1,2013.668,1218.779Z",
    transform: "translate(-2007.278 -1212.781)",
    fill: "#c29f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72578",
    "data-name": "Path 72578",
    d: "M2019.994,1217.645a2.663,2.663,0,0,1-1.214,1.271,7.076,7.076,0,0,1-6.4,0,2.663,2.663,0,0,1-1.214-1.271c-.331-.845.074-1.768,1.214-2.426a7.076,7.076,0,0,1,6.4,0C2019.92,1215.877,2020.325,1216.8,2019.994,1217.645Z",
    transform: "translate(-2009.188 -1214.068)",
    fill: "#703d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72579",
    "data-name": "Path 72579",
    d: "M2012.258,1249.35h0l-.037-.064Z",
    transform: "translate(-2010.086 -1240.88)",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72580",
    "data-name": "Path 72580",
    d: "M2020.368,1221.508a2.665,2.665,0,0,1-1.215,1.271,7.076,7.076,0,0,1-6.4,0,1.272,1.272,0,0,1,0-2.542,7.077,7.077,0,0,1,6.4,0A2.664,2.664,0,0,1,2020.368,1221.508Z",
    transform: "translate(-2009.562 -1217.931)",
    fill: "#603913"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(1610.216 197.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40421",
    "data-name": "Group 40421",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40420",
    "data-name": "Group 40420",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72581",
    "data-name": "Path 72581",
    d: "M2371.3,304.617c0-.026,0-.053,0-.08,0-.056-.005-.113-.008-.17s-.005-.133-.009-.2c0-.051-.009-.1-.012-.154s-.009-.12-.015-.18c0-.039-.005-.079-.009-.118-.008-.086-.019-.172-.029-.258-.006-.049-.01-.1-.016-.148,0-.017,0-.033-.006-.05q-.03-.233-.066-.468l0-.01c0-.023-.008-.045-.012-.068-.021-.131-.043-.261-.068-.392,0-.023-.01-.047-.014-.07-.012-.062-.025-.125-.038-.187s-.03-.152-.047-.229c-.009-.042-.02-.085-.03-.128q-.023-.1-.047-.2c-.012-.052-.024-.1-.037-.157s-.033-.126-.05-.189-.035-.136-.053-.2c-.009-.034-.017-.067-.027-.1-.025-.09-.052-.18-.079-.27-.017-.057-.033-.115-.05-.172l-.014-.05c-.05-.16-.1-.321-.154-.482l0-.006-.016-.046c-.048-.141-.1-.282-.147-.423-.008-.022-.017-.045-.025-.067l-.06-.16c-.029-.076-.057-.152-.086-.229-.019-.049-.039-.1-.058-.146l-.071-.177-.052-.129c-.036-.087-.074-.172-.111-.259l-.058-.137-.021-.049q-.1-.225-.2-.45l-.009-.019c-.021-.043-.042-.086-.063-.129-.055-.115-.109-.229-.166-.343l-.028-.054c-.047-.094-.1-.187-.145-.28-.039-.075-.076-.151-.116-.225-.007-.014-.015-.027-.023-.041q-.194-.362-.4-.717l-.034-.061c-.036-.06-.073-.119-.109-.179-.058-.1-.117-.194-.176-.29s-.107-.17-.162-.255-.121-.189-.183-.283l-.061-.094c-.02-.029-.041-.058-.061-.087-.172-.255-.347-.507-.529-.753h0v0q-.194-.263-.4-.519l-.017-.023c-.1-.123-.2-.245-.3-.366-.02-.024-.04-.05-.06-.074l0,0q-.178-.214-.36-.421l-.018-.02c-.037-.042-.075-.083-.113-.125-.077-.086-.153-.172-.231-.256l-.045-.047c-.052-.056-.106-.111-.159-.167s-.117-.125-.177-.185l-.067-.066-.176-.173c-.05-.049-.1-.1-.15-.148l-.087-.081-.191-.178c-.044-.04-.087-.082-.131-.122s-.071-.061-.105-.092c-.064-.057-.128-.112-.193-.168-.039-.034-.077-.069-.116-.1s-.085-.069-.128-.1l-.189-.155-.1-.079c-.053-.042-.108-.082-.161-.123l-.176-.134-.072-.055c-.072-.053-.146-.1-.218-.155l-.148-.105-.039-.027q-.2-.135-.4-.262l0,0-.03-.018c-.12-.076-.24-.15-.361-.221l-.091-.053-155.557-89.811q-.149-.086-.3-.166l-.112-.058-.152-.079-.118-.061c-.063-.031-.125-.059-.188-.088l-.134-.063-.055-.026q-.187-.084-.373-.158h0q-.189-.075-.375-.141l-.048-.016-.135-.044c-.063-.021-.127-.043-.19-.062l-.094-.026-.165-.045c-.042-.011-.084-.024-.127-.035s-.087-.019-.131-.029l-.164-.036-.086-.019c-.051-.01-.1-.016-.153-.025s-.126-.022-.189-.031l-.067-.011c-.052-.007-.1-.01-.154-.016-.067-.007-.135-.015-.2-.02l-.059-.006c-.045,0-.089,0-.134,0-.08,0-.159-.007-.237-.008l-.066,0q-.13,0-.258.007l-.033,0c-.064,0-.129.008-.193.014-.041,0-.08.009-.12.014l-.091.011c-.11.015-.219.032-.326.053l-.01,0c-.03.006-.058.014-.087.021-.089.02-.177.04-.263.065-.042.012-.083.026-.125.039s-.111.033-.166.052l-.04.017c-.084.03-.165.065-.247.1-.04.017-.08.032-.119.051-.119.055-.235.115-.349.181l-6.492,3.773c.113-.066.23-.126.348-.181.039-.018.08-.034.119-.051.081-.035.163-.07.246-.1.068-.025.137-.047.206-.069.042-.013.083-.027.125-.039.087-.024.175-.045.263-.065.029-.006.058-.015.087-.02.11-.022.222-.04.335-.055l.091-.011c.1-.012.207-.022.313-.028l.033,0c.106-.005.215-.006.324-.005.078,0,.158,0,.237.008.064,0,.128.005.193.01s.134.013.2.021.146.016.221.026.126.02.189.031c.079.014.159.028.239.044l.164.036c.086.02.171.041.258.064l.165.046c.094.027.189.057.283.088l.135.044c.14.048.281.1.423.157h0c.142.057.284.119.428.184l.134.063q.152.071.305.149l.152.079c.135.072.271.145.408.224l155.557,89.811c.152.088.3.179.452.274l.03.018c.147.094.293.191.438.291l.148.105c.1.069.194.138.29.21l.176.134q.13.1.259.2c.063.051.126.1.189.154q.123.1.244.206.1.083.192.168.119.106.238.215l.191.177c.08.076.158.152.237.23.059.058.117.115.175.173.082.082.163.167.244.251.053.056.107.111.159.167.093.1.185.2.276.3l.113.125q.193.219.382.446l.056.07q.16.194.317.393.2.256.395.519l0,0c.182.246.357.5.529.753.041.06.082.12.122.181q.093.141.183.283c.054.085.109.17.162.255s.118.193.176.289c.048.08.1.16.144.241q.207.355.4.717c.048.089.094.178.14.267s.1.185.144.278c.067.132.131.265.195.4.021.043.042.085.062.128q.121.257.235.517c.02.046.039.092.059.138q.083.193.162.387.036.088.072.177.074.187.144.373c.02.054.041.108.061.162q.09.246.173.492c0,.014.01.029.015.043q.09.268.171.537c.018.058.034.116.051.174.036.123.072.247.1.37.019.068.036.136.054.2q.045.173.086.345.024.1.047.2.04.178.076.356c.013.062.026.125.038.187.03.154.057.309.082.463,0,.023.008.046.012.068.028.176.052.352.074.528.006.05.011.1.016.149q.022.189.038.376.007.09.014.18c.009.119.016.237.021.355,0,.057.006.114.008.17.006.167.01.334.01.5l-.3,107c0,.174-.005.344-.012.511,0,.048-.006.094-.009.141-.007.115-.014.229-.024.341-.006.065-.013.129-.02.193-.01.1-.021.189-.034.282-.009.068-.02.136-.03.2q-.021.128-.044.253t-.045.223q-.025.112-.051.222c-.021.087-.043.172-.067.256-.018.066-.037.131-.056.195-.031.1-.064.2-.1.3-.021.061-.042.123-.065.182l-.035.088c-.04.1-.082.2-.126.295l-.026.058q-.084.18-.178.35l0,0c-.062.112-.127.22-.195.325l-.043.063c-.051.078-.1.154-.159.228l-.067.088q-.078.1-.16.2c-.021.024-.041.049-.062.073q-.113.126-.232.243l-.035.032c-.069.066-.141.13-.214.191-.026.022-.053.044-.08.065q-.094.075-.191.145l-.081.058c-.09.061-.181.121-.275.175h0l6.492-3.773c.094-.055.186-.114.276-.176l.08-.057q.1-.07.191-.145l.08-.065c.073-.061.145-.125.214-.191l.035-.032c.08-.078.157-.159.232-.243l.062-.073c.055-.064.108-.129.16-.2l.068-.088q.082-.111.159-.228l.043-.063.013-.018q.094-.148.182-.307l0,0q.088-.159.167-.327l.01-.023.026-.057q.066-.144.126-.295c.012-.029.024-.059.036-.089s.018-.044.026-.066.025-.078.039-.116c.034-.1.067-.2.1-.3.008-.027.018-.052.026-.079s.02-.078.03-.116q.035-.126.066-.255c.009-.035.019-.069.027-.1s.015-.079.024-.118q.023-.11.045-.223c.007-.039.016-.076.023-.115s.014-.093.021-.139q.016-.1.031-.2c0-.035.011-.068.015-.1.007-.058.012-.119.018-.179s.014-.127.02-.192c0-.026.006-.051.008-.078.007-.086.011-.175.016-.264,0-.047.007-.094.009-.141,0-.012,0-.023,0-.035q.01-.222.01-.45c0-.009,0-.018,0-.027l.3-107C2371.31,304.9,2371.307,304.758,2371.3,304.617Z",
    transform: "translate(-2190.323 -197.865)",
    fill: "#d1d3d4"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40419",
    "data-name": "Group 40419",
    transform: "translate(0 3.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72582",
    "data-name": "Path 72582",
    d: "M2345.434,305.337c5.146,2.971,9.3,10.172,9.286,16.083l-.3,107c-.017,5.912-4.2,8.3-9.347,5.327l-155.557-89.811c-5.145-2.97-9.3-10.173-9.286-16.085l.3-107c.017-5.912,4.2-8.3,9.347-5.325Z",
    transform: "translate(-2180.226 -214.248)",
    fill: "#f1f2f2"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40475",
    "data-name": "Group 40475",
    transform: "translate(6.727 16.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40462",
    "data-name": "Group 40462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40423",
    "data-name": "Group 40423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40422",
    "data-name": "Group 40422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72583",
    "data-name": "Path 72583",
    d: "M2209.437,268.127v104.28a13.773,13.773,0,0,0,6.291,10.809L2359.736,465.7c3.475,1.99,6.291.377,6.291-3.6V357.816Z",
    transform: "translate(-2209.437 -268.127)",
    fill: "#f1f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40461",
    "data-name": "Group 40461",
    transform: "translate(7.528 37.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40424",
    "data-name": "Group 40424",
    transform: "translate(10.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72584",
    "data-name": "Path 72584",
    d: "M2409.441,566.072,2286.1,495.428V432.037l.875.5v62.388l122.463,70.143Z",
    transform: "translate(-2286.103 -432.037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40425",
    "data-name": "Group 40425",
    transform: "translate(10.564 52.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72585",
    "data-name": "Path 72585",
    d: "M2410.9,729.93,2288,659.536v-1l122.9,70.394Z",
    transform: "translate(-2288.003 -658.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40426",
    "data-name": "Group 40426",
    transform: "translate(10.564 41.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72586",
    "data-name": "Path 72586",
    d: "M2410.9,684.413,2288,614.019v-1l122.9,70.394Z",
    transform: "translate(-2288.003 -613.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40427",
    "data-name": "Group 40427",
    transform: "translate(10.564 31.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72587",
    "data-name": "Path 72587",
    d: "M2410.9,638.9,2288,568.5v-1l122.9,70.394Z",
    transform: "translate(-2288.003 -567.501)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40428",
    "data-name": "Group 40428",
    transform: "translate(10.564 20.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72588",
    "data-name": "Path 72588",
    d: "M2410.9,593.38,2288,522.986v-1l122.9,70.394Z",
    transform: "translate(-2288.003 -521.984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40429",
    "data-name": "Group 40429",
    transform: "translate(10.564 10.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72589",
    "data-name": "Path 72589",
    d: "M2410.9,547.862,2288,477.469v-1l122.9,70.394Z",
    transform: "translate(-2288.003 -476.466)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40446",
    "data-name": "Group 40446",
    transform: "translate(16.413 69.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40430",
    "data-name": "Group 40430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72590",
    "data-name": "Path 72590",
    d: "M2314.094,735.087l-.01-.006-.593.027-.089-.453.746-.03.394.225v3.908l-.446-.255Z",
    transform: "translate(-2313.401 -734.624)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40431",
    "data-name": "Group 40431",
    transform: "translate(10.176 5.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72591",
    "data-name": "Path 72591",
    d: "M2357.592,763.085v-.325l.362-.2c.871-.451,1.265-.73,1.27-1.317a1.29,1.29,0,0,0-.677-1.151.827.827,0,0,0-.724-.085l-.147-.457a1.131,1.131,0,0,1,.966.156,2.065,2.065,0,0,1,1.044,1.734c0,.721-.457,1.043-1.176,1.425l-.273.132v.012l1.532.878v.439Z",
    transform: "translate(-2357.592 -759.505)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40432",
    "data-name": "Group 40432",
    transform: "translate(20.646 11.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72592",
    "data-name": "Path 72592",
    d: "M2403.183,788.473a2.931,2.931,0,0,0,.756.679c.593.34.777.012.771-.316a1.628,1.628,0,0,0-.882-1.287l-.257-.147v-.4l.257.147c.336.193.761.237.761-.225a1.1,1.1,0,0,0-.6-.932.982.982,0,0,0-.682-.132l-.121-.454a1.333,1.333,0,0,1,.892.211,1.822,1.822,0,0,1,.976,1.491c0,.4-.21.625-.63.559v.012a1.972,1.972,0,0,1,.761,1.44c0,.625-.425.929-1.244.46a3.2,3.2,0,0,1-.887-.772Z",
    transform: "translate(-2403.057 -785.392)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40433",
    "data-name": "Group 40433",
    transform: "translate(29.876 17.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72593",
    "data-name": "Path 72593",
    d: "M2444.725,814.811v-1.064l-1.585-.908v-.348l1.522-1.623.5.285v2.429l.478.274v.415l-.478-.274v1.064Zm0-1.479v-1.3q0-.307.016-.6l-.016-.009c-.1.169-.189.289-.283.415l-.835.85v.012Z",
    transform: "translate(-2443.14 -810.867)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40434",
    "data-name": "Group 40434",
    transform: "translate(40.829 23.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72594",
    "data-name": "Path 72594",
    d: "M2491.4,836.64l-.01-.006-.593.027-.089-.454.745-.03.394.225v3.908l-.446-.256Z",
    transform: "translate(-2490.704 -836.177)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40435",
    "data-name": "Group 40435",
    transform: "translate(43.522 24.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72595",
    "data-name": "Path 72595",
    d: "M2503.093,843.34l-.01-.006-.593.027-.089-.454.746-.03.394.225v3.908l-.446-.256Z",
    transform: "translate(-2502.4 -842.877)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40436",
    "data-name": "Group 40436",
    transform: "translate(52.586 30.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72596",
    "data-name": "Path 72596",
    d: "M2541.757,868.568v-.324l.362-.2c.871-.451,1.265-.73,1.27-1.317a1.291,1.291,0,0,0-.677-1.151.828.828,0,0,0-.724-.084l-.147-.457a1.131,1.131,0,0,1,.966.156,2.065,2.065,0,0,1,1.044,1.734c0,.721-.457,1.043-1.176,1.425l-.273.132v.012l1.532.878v.439Z",
    transform: "translate(-2541.757 -864.988)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40437",
    "data-name": "Group 40437",
    transform: "translate(55.122 32.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72597",
    "data-name": "Path 72597",
    d: "M2554.355,877.6v-1.064l-1.585-.908v-.348l1.522-1.623.5.286v2.429l.477.273v.415l-.477-.274v1.064Zm0-1.479v-1.3q0-.307.016-.6l-.016-.009c-.1.169-.189.289-.283.415l-.835.85v.012Z",
    transform: "translate(-2552.77 -873.659)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40438",
    "data-name": "Group 40438",
    transform: "translate(67.991 38.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72598",
    "data-name": "Path 72598",
    d: "M2608.656,906.886v-.324l.362-.2c.871-.451,1.265-.731,1.27-1.317a1.291,1.291,0,0,0-.677-1.151.828.828,0,0,0-.725-.084l-.147-.457a1.132,1.132,0,0,1,.966.156,2.065,2.065,0,0,1,1.044,1.734c0,.721-.457,1.043-1.176,1.425l-.273.132v.012l1.533.878v.439Z",
    transform: "translate(-2608.656 -903.306)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40439",
    "data-name": "Group 40439",
    transform: "translate(70.627 40.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72599",
    "data-name": "Path 72599",
    d: "M2622.107,912.541a2.042,2.042,0,0,0-.346-.174.79.79,0,0,0-1.186.709l.016.009c.162-.154.446-.2.824.021a2.184,2.184,0,0,1,1.028,1.852c0,.715-.425,1.133-1.134.727a2.7,2.7,0,0,1-1.207-2.357,1.551,1.551,0,0,1,.577-1.431,1.237,1.237,0,0,1,1.092.048,2.643,2.643,0,0,1,.336.162Zm-.131,2.179a1.484,1.484,0,0,0-.7-1.3.453.453,0,0,0-.661.1.335.335,0,0,0-.052.2,1.784,1.784,0,0,0,.75,1.548C2621.708,915.5,2621.976,915.279,2621.976,914.72Z",
    transform: "translate(-2620.102 -911.792)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40440",
    "data-name": "Group 40440",
    transform: "translate(83.38 47.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72600",
    "data-name": "Path 72600",
    d: "M2675.611,944.511a2.924,2.924,0,0,0,.755.679c.593.34.777.012.771-.316a1.628,1.628,0,0,0-.882-1.286l-.257-.147v-.4l.257.147c.336.192.761.237.761-.225a1.1,1.1,0,0,0-.6-.932.98.98,0,0,0-.683-.132l-.12-.454a1.334,1.334,0,0,1,.892.21,1.822,1.822,0,0,1,.976,1.491c0,.4-.21.625-.63.559v.012a1.971,1.971,0,0,1,.761,1.44c0,.625-.425.929-1.244.46a3.2,3.2,0,0,1-.887-.772Z",
    transform: "translate(-2675.485 -941.431)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40441",
    "data-name": "Group 40441",
    transform: "translate(86.09 49.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72601",
    "data-name": "Path 72601",
    d: "M2687.252,951.9v-.324l.362-.2c.871-.451,1.265-.73,1.27-1.317a1.292,1.292,0,0,0-.677-1.151.828.828,0,0,0-.724-.084l-.147-.457a1.131,1.131,0,0,1,.965.156,2.065,2.065,0,0,1,1.045,1.734c0,.721-.457,1.043-1.176,1.425l-.273.132v.012l1.532.878v.439Z",
    transform: "translate(-2687.252 -948.323)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40442",
    "data-name": "Group 40442",
    transform: "translate(97.531 56.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72602",
    "data-name": "Path 72602",
    d: "M2738.52,983.087v-1.064l-1.585-.908v-.348l1.522-1.623.5.286v2.429l.478.273v.415l-.478-.273v1.064Zm0-1.479v-1.3q0-.307.016-.6l-.016-.009c-.1.169-.189.289-.283.415l-.835.85v.012Z",
    transform: "translate(-2736.935 -979.143)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40443",
    "data-name": "Group 40443",
    transform: "translate(100.382 57.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72603",
    "data-name": "Path 72603",
    d: "M2749.317,987.453v-.325l.362-.2c.871-.451,1.265-.73,1.27-1.317a1.291,1.291,0,0,0-.677-1.151.827.827,0,0,0-.724-.085l-.147-.457a1.132,1.132,0,0,1,.966.156,2.065,2.065,0,0,1,1.044,1.734c0,.721-.457,1.043-1.176,1.425l-.273.132v.012l1.532.878v.439Z",
    transform: "translate(-2749.317 -983.873)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40444",
    "data-name": "Group 40444",
    transform: "translate(112.044 63.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72604",
    "data-name": "Path 72604",
    d: "M2802.109,1012.687v.348l-1.485,2.709-.478-.274,1.479-2.609v-.012l-1.668-.956v-.439Z",
    transform: "translate(-2799.958 -1011.455)",
    fill: "#004166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40445",
    "data-name": "Group 40445",
    transform: "translate(114.984 65.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72605",
    "data-name": "Path 72605",
    d: "M2813.418,1021.084l-.01-.006-.593.027-.089-.454.745-.03.394.225v3.908l-.446-.256Z",
    transform: "translate(-2812.725 -1020.621)",
    fill: "#004166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40448",
    "data-name": "Group 40448",
    transform: "translate(0 1.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40447",
    "data-name": "Group 40447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72606",
    "data-name": "Path 72606",
    d: "M2244.134,442.15l-.941-.539-.19,1.026-.875-.5.958-4.575,1.171.671.957,5.672-.891-.51Zm-.115-.813-.355-2.348-.355,1.941Z",
    transform: "translate(-2242.128 -437.561)",
    fill: "#004166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40450",
    "data-name": "Group 40450",
    transform: "translate(0.281 12.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40449",
    "data-name": "Group 40449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72607",
    "data-name": "Path 72607",
    d: "M2246.178,491.155v.417c0,.739-.536.915-1.37.438l-1.461-.837V486.05l1.387.794a2.5,2.5,0,0,1,1.37,2.007v.271c0,.461-.206.672-.586.645A1.985,1.985,0,0,1,2246.178,491.155Zm-1.956-3.872v1.391l.388.222c.421.241.619.178.619-.194v-.366a.944.944,0,0,0-.536-.783Zm1.081,3.291a1.019,1.019,0,0,0-.619-.9l-.462-.265v1.537l.545.312c.338.194.536.132.536-.169Z",
    transform: "translate(-2243.347 -486.05)",
    fill: "#004166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40452",
    "data-name": "Group 40452",
    transform: "translate(0.206 24.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40451",
    "data-name": "Group 40451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72608",
    "data-name": "Path 72608",
    d: "M2243.024,541.532v-2.84c0-.718.553-.9,1.37-.431a2.543,2.543,0,0,1,1.37,2v.6l-.858-.491v-.6a.943.943,0,0,0-.5-.772c-.3-.17-.5-.106-.5.195v2.84a.943.943,0,0,0,.5.772c.3.17.5.105.5-.195v-.732l.858.491v.732c0,.718-.553.9-1.37.431A2.543,2.543,0,0,1,2243.024,541.532Z",
    transform: "translate(-2243.024 -538.003)",
    fill: "#004166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40454",
    "data-name": "Group 40454",
    transform: "translate(0.281 35.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40453",
    "data-name": "Group 40453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72609",
    "data-name": "Path 72609",
    d: "M2243.347,586.393l1.37.785a2.5,2.5,0,0,1,1.37,2.007v2.679c0,.739-.536.915-1.37.438l-1.37-.785Zm1.329,5.153c.338.194.537.132.537-.168v-2.708a.944.944,0,0,0-.537-.783l-.454-.26v3.66Z",
    transform: "translate(-2243.347 -586.393)",
    fill: "#004166"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40457",
    "data-name": "Group 40457",
    transform: "translate(97.469 31.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40455",
    "data-name": "Group 40455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72610",
    "data-name": "Path 72610",
    d: "M2672.172,581.486l-6.778-3.882v-7.765l6.778,3.882Z",
    transform: "translate(-2665.394 -569.839)",
    fill: "#f65841"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40456",
    "data-name": "Group 40456",
    transform: "translate(9.17 7.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72611",
    "data-name": "Path 72611",
    d: "M2712.284,609.053l-7.07-4.05v-2.74l7.07,4.05Z",
    transform: "translate(-2705.214 -602.264)",
    fill: "#fbb3a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40460",
    "data-name": "Group 40460",
    transform: "translate(119.72 44.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40458",
    "data-name": "Group 40458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72612",
    "data-name": "Path 72612",
    d: "M2768.8,636.83l-6.778-3.882v-7.765l6.778,3.882Z",
    transform: "translate(-2762.021 -625.183)",
    fill: "#005d92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40459",
    "data-name": "Group 40459",
    transform: "translate(9.17 7.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72613",
    "data-name": "Path 72613",
    d: "M2808.911,664.4l-7.07-4.05v-2.74l7.07,4.05Z",
    transform: "translate(-2801.841 -657.609)",
    fill: "#d5e8f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40463",
    "data-name": "Group 40463",
    transform: "translate(26.926 59.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72614",
    "data-name": "Path 72614",
    d: "M2326.365,554.141l9.982,5.717v39.581l-9.982-5.717Z",
    transform: "translate(-2326.365 -548.222)",
    fill: "#005d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72615",
    "data-name": "Path 72615",
    d: "M2326.365,534.357l9.982,5.717v-5.919l-9.982-5.717Z",
    transform: "translate(-2326.365 -528.439)",
    fill: "#f87664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40464",
    "data-name": "Group 40464",
    transform: "translate(41.275 95.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72616",
    "data-name": "Path 72616",
    d: "M2388.676,691.288l9.982,5.717v16.217l-9.982-5.717Z",
    transform: "translate(-2388.676 -688.863)",
    fill: "#8cc1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72617",
    "data-name": "Path 72617",
    d: "M2388.676,683.183l9.982,5.717v-2.425l-9.982-5.717Z",
    transform: "translate(-2388.676 -680.758)",
    fill: "#f65841"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40465",
    "data-name": "Group 40465",
    transform: "translate(55.624 92.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72618",
    "data-name": "Path 72618",
    d: "M2450.987,686.714l9.982,5.717V717.92l-9.982-5.717Z",
    transform: "translate(-2450.987 -682.902)",
    fill: "#005d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72619",
    "data-name": "Path 72619",
    d: "M2450.987,673.974l9.982,5.717v-3.812l-9.982-5.717Z",
    transform: "translate(-2450.987 -670.162)",
    fill: "#fbb3a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40466",
    "data-name": "Group 40466",
    transform: "translate(69.973 107.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72620",
    "data-name": "Path 72620",
    d: "M2513.3,747.6l9.982,5.717v19.687l-9.982-5.717Z",
    transform: "translate(-2513.298 -744.657)",
    fill: "#d5e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72621",
    "data-name": "Path 72621",
    d: "M2513.3,737.761l9.982,5.717v-2.944l-9.982-5.717Z",
    transform: "translate(-2513.298 -734.817)",
    fill: "#f87664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40467",
    "data-name": "Group 40467",
    transform: "translate(84.321 102.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72622",
    "data-name": "Path 72622",
    d: "M2575.608,733.345l9.982,5.717v31.188l-9.982-5.717Z",
    transform: "translate(-2575.608 -728.682)",
    fill: "#005d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72623",
    "data-name": "Path 72623",
    d: "M2575.608,717.757l9.982,5.717v-4.664l-9.982-5.717Z",
    transform: "translate(-2575.608 -713.093)",
    fill: "#f65841"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40468",
    "data-name": "Group 40468",
    transform: "translate(98.67 104.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72624",
    "data-name": "Path 72624",
    d: "M2637.919,745.1l9.982,5.717v36.7l-9.982-5.717Z",
    transform: "translate(-2637.919 -739.609)",
    fill: "#3992d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72625",
    "data-name": "Path 72625",
    d: "M2637.919,726.753l9.982,5.717v-5.488l-9.982-5.717Z",
    transform: "translate(-2637.919 -721.265)",
    fill: "#f87664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40469",
    "data-name": "Group 40469",
    transform: "translate(113.019 106.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72626",
    "data-name": "Path 72626",
    d: "M2700.23,758.829l9.982,5.717V806.3l-9.982-5.717Z",
    transform: "translate(-2700.23 -752.585)",
    fill: "#005d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72627",
    "data-name": "Path 72627",
    d: "M2700.23,737.958l9.982,5.717v-6.244l-9.982-5.717Z",
    transform: "translate(-2700.23 -731.714)",
    fill: "#fbb3a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40470",
    "data-name": "Group 40470",
    transform: "translate(127.368 105.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72628",
    "data-name": "Path 72628",
    d: "M2762.541,759.422l9.982,5.717v49.839l-9.982-5.717Z",
    transform: "translate(-2762.541 -751.97)",
    fill: "#004166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72629",
    "data-name": "Path 72629",
    d: "M2762.541,734.512l9.982,5.717v-7.453l-9.982-5.717Z",
    transform: "translate(-2762.541 -727.059)",
    fill: "#f87664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40474",
    "data-name": "Group 40474",
    transform: "translate(28.943 48.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40473",
    "data-name": "Group 40473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40472",
    "data-name": "Group 40472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72630",
    "data-name": "Path 72630",
    d: "M2378.593,536.682l-14.8-25.288-13.58-.024-15.092-31.156,1.581-.766,14.613,30.167,13.486.024,14.526,24.828,18.393-7.725,9.647,5.169,8.662-4.117,16.682.745-.078,1.755-16.244-.725-9.068,4.31-9.692-5.193Z",
    transform: "translate(-2335.125 -479.449)",
    fill: "#f87664"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40471",
    "data-name": "Group 40471",
    transform: "translate(94.628 46.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72631",
    "data-name": "Path 72631",
    d: "M2746.055,687.381l1.708-3.569-1.383-3.707,8.462,4.024Z",
    transform: "translate(-2746.055 -680.104)",
    fill: "#f87664"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialImage);
export default __webpack_public_path__ + "static/media/financialImage.bdbd0f95404348d5a1cc04285c6dfd67.svg";
export { ForwardRef as ReactComponent };